var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 31,
    viewBox: "0 0 134 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_121_1869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 3,
    width: 5,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.499 14.7791C22.499 18.6623 22.499 22.5455 22.499 26.4287C22.499 26.5451 22.5141 26.5471 22.3843 26.5471C21.1593 26.5471 19.9342 26.5471 18.7091 26.5471C18.7057 26.5471 18.703 26.5471 18.6995 26.5471C18.6313 26.5471 18.5972 26.5132 18.5972 26.4452C18.5972 22.4401 18.5972 18.4358 18.5972 14.4307C18.5972 14.4148 18.5972 14.3997 18.5972 14.3839C18.5958 14.3474 18.6158 14.3343 18.6494 14.335C18.6652 14.335 18.6803 14.335 18.6961 14.335C19.1782 14.335 19.6602 14.335 20.1416 14.335C20.1539 14.335 20.1663 14.3357 20.1787 14.335C20.2206 14.3322 20.2446 14.3467 20.2398 14.3935C20.2384 14.4087 20.2398 14.4245 20.2398 14.4403C20.2398 17.8905 20.2398 21.3406 20.2398 24.7907C20.2398 24.8004 20.2398 24.8093 20.2398 24.819C20.2405 24.9112 20.2405 24.9119 20.3332 24.9126C20.476 24.9126 20.6195 24.9126 20.7624 24.9126C20.8461 24.9126 20.8564 24.9009 20.8585 24.8141C20.8585 24.7983 20.8585 24.7832 20.8585 24.7673C20.8585 21.1395 20.8585 17.5118 20.8585 13.884C20.8585 13.7015 20.8605 13.7291 20.7019 13.7291C20.04 13.7284 19.3773 13.7291 18.7153 13.7291C18.6995 13.7291 18.6844 13.7291 18.6686 13.7291C18.5986 13.7263 18.5986 13.7263 18.5972 13.6527C18.5972 13.6368 18.5972 13.6217 18.5972 13.6058C18.5972 10.9165 18.5972 8.2265 18.5972 5.53717C18.5972 5.52133 18.5979 5.50619 18.5972 5.49035C18.5938 5.44697 18.6116 5.42563 18.6563 5.42907C18.6686 5.42976 18.681 5.42907 18.6934 5.42907C19.1782 5.42907 19.6636 5.42907 20.1485 5.42907C20.2398 5.42907 20.2398 5.42907 20.2398 5.52271C20.2398 7.05603 20.2398 8.58934 20.2398 10.1227C20.2398 10.7368 20.2398 11.3503 20.2398 11.9644C20.2398 11.9741 20.2398 11.983 20.2398 11.9927C20.2405 12.0856 20.2405 12.0863 20.3332 12.0863C20.476 12.0863 20.6195 12.0863 20.7624 12.0863C20.8578 12.0863 20.8585 12.0856 20.8585 11.9851C20.8585 11.9479 20.8585 11.91 20.8585 11.8729C20.8585 8.94944 20.8585 6.02601 20.8585 3.10259C20.8585 3.09639 20.8585 3.0902 20.8585 3.084C20.8592 3.00275 20.8592 3.00207 20.9416 3.00207C21.4326 3 21.9235 3 22.4152 3C22.4976 3 22.4983 3.00069 22.499 3.08193C22.499 3.12531 22.499 3.16937 22.499 3.21275C22.499 7.06773 22.499 10.9241 22.499 14.7791Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_121_1869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.514 3H18.593V3.12806H22.514V3Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 3.12805H18.5931V3.25612H22.5141V3.12805Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 3.25612H18.5931V3.38418H22.5141V3.25612Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 3.38419H18.5931V3.51225H22.5141V3.38419Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 3.51225H18.5931V3.64032H22.5141V3.51225Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 3.63962H18.5931V3.76768H22.5141V3.63962Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 3.76768H18.5931V3.89575H22.5141V3.76768Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 3.89575H18.5931V4.02382H22.5141V3.89575Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 4.02382H18.5931V4.15188H22.5141V4.02382Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 4.15189H18.5931V4.27995H22.5141V4.15189Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 4.27994H18.5931V4.408H22.5141V4.27994Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 4.408H18.5931V4.53607H22.5141V4.408Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 4.53607H18.5931V4.66414H22.5141V4.53607Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 4.66344H18.5931V4.7915H22.5141V4.66344Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 4.7915H18.5931V4.91957H22.5141V4.7915Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 4.91957H18.5931V5.04763H22.5141V4.91957Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 5.04764H18.5931V5.1757H22.5141V5.04764Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 5.17569H18.5931V5.30375H22.5141V5.17569Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 5.30376H18.5931V5.43182H22.5141V5.30376Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 5.43182H18.5931V5.55989H22.5141V5.43182Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 5.55919H18.5931V5.68725H22.5141V5.55919Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 5.68726H18.5931V5.81532H22.5141V5.68726Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 5.81532H18.5931V5.94339H22.5141V5.81532Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 5.94337H18.5931V6.07144H22.5141V5.94337Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 6.07144H18.5931V6.1995H22.5141V6.07144Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 6.19951H18.5931V6.32757H22.5141V6.19951Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 6.32758H18.5931V6.45564H22.5141V6.32758Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 6.45563H18.5931V6.58369H22.5141V6.45563Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 6.58301H18.5931V6.71107H22.5141V6.58301Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 6.71107H18.5931V6.83914H22.5141V6.71107Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 6.83914H18.5931V6.96721H22.5141V6.83914Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 6.96719H18.5931V7.09526H22.5141V6.96719Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 7.09526H18.5931V7.22332H22.5141V7.09526Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 7.22333H18.5931V7.35139H22.5141V7.22333Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 7.35138H18.5931V7.47944H22.5141V7.35138Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 7.47945H18.5931V7.60751H22.5141V7.47945Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 7.60684H18.5931V7.7349H22.5141V7.60684Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 7.73489H18.5931V7.86296H22.5141V7.73489Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 7.86296H18.5931V7.99102H22.5141V7.86296Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 7.99103H18.5931V8.11909H22.5141V7.99103Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 8.11909H18.5931V8.24716H22.5141V8.11909Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 8.24715H18.5931V8.37521H22.5141V8.24715Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 8.37521H18.5931V8.50328H22.5141V8.37521Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 8.50258H18.5931V8.63064H22.5141V8.50258Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 8.63065H18.5931V8.75871H22.5141V8.63065Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 8.75871H18.5931V8.88678H22.5141V8.75871Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 8.88678H18.5931V9.01484H22.5141V8.88678Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 9.01485H18.5931V9.14291H22.5141V9.01485Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 9.1429H18.5931V9.27096H22.5141V9.1429Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 9.27097H18.5931V9.39903H22.5141V9.27097Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 9.39903H18.5931V9.5271H22.5141V9.39903Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 9.5264H18.5931V9.65446H22.5141V9.5264Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 9.65446H18.5931V9.78253H22.5141V9.65446Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 9.78253H18.5931V9.9106H22.5141V9.78253Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 9.9106H18.5931V10.0387H22.5141V9.9106Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 10.0387H18.5931V10.1667H22.5141V10.0387Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 10.1667H18.5931V10.2948H22.5141V10.1667Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 10.2948H18.5931V10.4228H22.5141V10.2948Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 10.4221H18.5931V10.5502H22.5141V10.4221Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 10.5502H18.5931V10.6783H22.5141V10.5502Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 10.6783H18.5931V10.8063H22.5141V10.6783Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 10.8064H18.5931V10.9344H22.5141V10.8064Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 10.9344H18.5931V11.0625H22.5141V10.9344Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 11.0625H18.5931V11.1905H22.5141V11.0625Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 11.1905H18.5931V11.3186H22.5141V11.1905Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 11.3186H18.5931V11.4467H22.5141V11.3186Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 11.446H18.5931V11.574H22.5141V11.446Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 11.574H18.5931V11.7021H22.5141V11.574Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 11.7021H18.5931V11.8302H22.5141V11.7021Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 11.8302H18.5931V11.9582H22.5141V11.8302Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 11.9582H18.5931V12.0863H22.5141V11.9582Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 12.0863H18.5931V12.2144H22.5141V12.0863Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 12.2144H18.5931V12.3424H22.5141V12.2144Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 12.3424H18.5931V12.4705H22.5141V12.3424Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 12.4698H18.5931V12.5979H22.5141V12.4698Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 12.5979H18.5931V12.7259H22.5141V12.5979Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 12.7259H18.5931V12.854H22.5141V12.7259Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 12.854H18.5931V12.982H22.5141V12.854Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 12.982H18.5931V13.1101H22.5141V12.982Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 13.1101H18.5931V13.2382H22.5141V13.1101Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 13.2382H18.5931V13.3662H22.5141V13.2382Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 13.3655H18.5931V13.4936H22.5141V13.3655Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 13.4936H18.5931V13.6217H22.5141V13.4936Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 13.6217H18.5931V13.7497H22.5141V13.6217Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 13.7497H18.5931V13.8778H22.5141V13.7497Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 13.8778H18.5931V14.0059H22.5141V13.8778Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 14.0059H18.5931V14.1339H22.5141V14.0059Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 14.1339H18.5931V14.262H22.5141V14.1339Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 14.262H18.5931V14.3901H22.5141V14.262Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 14.3894H18.5931V14.5174H22.5141V14.3894Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 14.5174H18.5931V14.6455H22.5141V14.5174Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 14.6455H18.5931V14.7736H22.5141V14.6455Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 14.7736H18.5931V14.9016H22.5141V14.7736Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 14.9016H18.5931V15.0297H22.5141V14.9016Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 15.0297H18.5931V15.1577H22.5141V15.0297Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 15.1577H18.5931V15.2858H22.5141V15.1577Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 15.2851H18.5931V15.4132H22.5141V15.2851Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 15.4132H18.5931V15.5412H22.5141V15.4132Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 15.5412H18.5931V15.6693H22.5141V15.5412Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 15.6693H18.5931V15.7974H22.5141V15.6693Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 15.7974H18.5931V15.9254H22.5141V15.7974Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 15.9254H18.5931V16.0535H22.5141V15.9254Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 16.0535H18.5931V16.1816H22.5141V16.0535Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 16.1816H18.5931V16.3096H22.5141V16.1816Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 16.3089H18.5931V16.437H22.5141V16.3089Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 16.437H18.5931V16.5651H22.5141V16.437Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 16.5651H18.5931V16.6931H22.5141V16.5651Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 16.6931H18.5931V16.8212H22.5141V16.6931Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 16.8212H18.5931V16.9492H22.5141V16.8212Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 16.9493H18.5931V17.0773H22.5141V16.9493Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 17.0773H18.5931V17.2054H22.5141V17.0773Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 17.2054H18.5931V17.3334H22.5141V17.2054Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 17.3328H18.5931V17.4608H22.5141V17.3328Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 17.4608H18.5931V17.5889H22.5141V17.4608Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 17.5889H18.5931V17.7169H22.5141V17.5889Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 17.7169H18.5931V17.845H22.5141V17.7169Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 17.845H18.5931V17.9731H22.5141V17.845Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 17.9731H18.5931V18.1011H22.5141V17.9731Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 18.1011H18.5931V18.2292H22.5141V18.1011Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 18.2285H18.5931V18.3566H22.5141V18.2285Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 18.3566H18.5931V18.4846H22.5141V18.3566Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 18.4846H18.5931V18.6127H22.5141V18.4846Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 18.6127H18.5931V18.7408H22.5141V18.6127Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 18.7408H18.5931V18.8688H22.5141V18.7408Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 18.8688H18.5931V18.9969H22.5141V18.8688Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 18.9969H18.5931V19.125H22.5141V18.9969Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 19.125H18.5931V19.253H22.5141V19.125Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 19.2523H18.5931V19.3804H22.5141V19.2523Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 19.3804H18.5931V19.5085H22.5141V19.3804Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 19.5085H18.5931V19.6365H22.5141V19.5085Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 19.6365H18.5931V19.7646H22.5141V19.6365Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 19.7646H18.5931V19.8927H22.5141V19.7646Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 19.8926H18.5931V20.0207H22.5141V19.8926Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 20.0207H18.5931V20.1488H22.5141V20.0207Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 20.1481H18.5931V20.2761H22.5141V20.1481Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 20.2762H18.5931V20.4042H22.5141V20.2762Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 20.4042H18.5931V20.5323H22.5141V20.4042Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 20.5323H18.5931V20.6603H22.5141V20.5323Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 20.6603H18.5931V20.7884H22.5141V20.6603Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 20.7884H18.5931V20.9165H22.5141V20.7884Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 20.9165H18.5931V21.0445H22.5141V20.9165Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 21.0445H18.5931V21.1726H22.5141V21.0445Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 21.1719H18.5931V21.3H22.5141V21.1719Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 21.3H18.5931V21.428H22.5141V21.3Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 21.428H18.5931V21.5561H22.5141V21.428Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 21.5561H18.5931V21.6842H22.5141V21.5561Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 21.6841H18.5931V21.8122H22.5141V21.6841Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 21.8122H18.5931V21.9403H22.5141V21.8122Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 21.9403H18.5931V22.0683H22.5141V21.9403Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 22.0677H18.5931V22.1957H22.5141V22.0677Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 22.1957H18.5931V22.3238H22.5141V22.1957Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 22.3238H18.5931V22.4518H22.5141V22.3238Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 22.4518H18.5931V22.5799H22.5141V22.4518Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 22.5799H18.5931V22.708H22.5141V22.5799Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 22.708H18.5931V22.836H22.5141V22.708Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 22.836H18.5931V22.9641H22.5141V22.836Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 22.9641H18.5931V23.0922H22.5141V22.9641Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 23.0915H18.5931V23.2195H22.5141V23.0915Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 23.2195H18.5931V23.3476H22.5141V23.2195Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 23.3476H18.5931V23.4757H22.5141V23.3476Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 23.4757H18.5931V23.6037H22.5141V23.4757Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 23.6037H18.5931V23.7318H22.5141V23.6037Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 23.7318H18.5931V23.8599H22.5141V23.7318Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 23.8599H18.5931V23.9879H22.5141V23.8599Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 23.9879H18.5931V24.116H22.5141V23.9879Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 24.1153H18.5931V24.2434H22.5141V24.1153Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 24.2434H18.5931V24.3714H22.5141V24.2434Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 24.3714H18.5931V24.4995H22.5141V24.3714Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 24.4995H18.5931V24.6275H22.5141V24.4995Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 24.6275H18.5931V24.7556H22.5141V24.6275Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 24.7556H18.5931V24.8837H22.5141V24.7556Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 24.8837H18.5931V25.0117H22.5141V24.8837Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 25.011H18.5931V25.1391H22.5141V25.011Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 25.1391H18.5931V25.2672H22.5141V25.1391Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 25.2672H18.5931V25.3952H22.5141V25.2672Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 25.3952H18.5931V25.5233H22.5141V25.3952Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 25.5233H18.5931V25.6514H22.5141V25.5233Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 25.6514H18.5931V25.7794H22.5141V25.6514Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 25.7794H18.5931V25.9075H22.5141V25.7794Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 25.9075H18.5931V26.0356H22.5141V25.9075Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 26.0349H18.5931V26.1629H22.5141V26.0349Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 26.1629H18.5931V26.291H22.5141V26.1629Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 26.291H18.5931V26.4191H22.5141V26.291Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5141 26.4191H18.5931V26.5471H22.5141V26.4191Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_121_1869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 5,
    width: 5,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0332 26.4287V9.57116C27.0332 9.07887 27.0332 8.58659 27.0332 8.09361C27.0332 8.04128 27.0195 7.99997 26.9845 7.96004C26.6796 7.61096 26.3774 7.25982 26.0725 6.91075C25.6598 6.43705 25.2437 5.96611 24.8331 5.49034C24.7912 5.44146 24.7493 5.427 24.6888 5.427C24.204 5.42838 23.7192 5.427 23.2337 5.427C23.2152 5.427 23.1967 5.427 23.1774 5.427C23.1479 5.427 23.1307 5.44077 23.1314 5.47244C23.1314 5.49035 23.1314 5.50962 23.1314 5.52821C23.1225 8.64167 23.1486 11.7551 23.1191 14.8679C23.1143 15.4311 23.1259 15.995 23.128 16.5589C23.1362 19.8465 23.1314 23.1349 23.1314 26.4232C23.1314 26.4383 23.1314 26.4542 23.1314 26.4693C23.1328 26.5437 23.1335 26.5437 23.2028 26.5464C23.2214 26.5464 23.2399 26.5464 23.2592 26.5464H24.649C24.7864 26.5464 24.774 26.5561 24.774 26.4197V16.5272C24.774 16.4274 24.774 16.4267 24.8701 16.4267C25.0102 16.4267 25.1503 16.4267 25.2897 16.4267C25.392 16.4267 25.392 16.4267 25.392 16.53V26.4315C25.392 26.45 25.3934 26.4686 25.392 26.4879C25.3879 26.534 25.4119 26.5492 25.4538 26.5464C25.4689 26.5451 25.4847 26.5464 25.5005 26.5464C25.973 26.5464 26.4454 26.5464 26.9185 26.5464C27.049 26.5464 27.0332 26.5451 27.0332 26.4287ZM25.2595 14.7832C25.1263 14.7832 24.9917 14.7846 24.8585 14.7832C24.7809 14.7832 24.7747 14.7763 24.774 14.6958C24.774 14.4651 24.774 14.2351 24.774 14.0038V11.0494C24.774 9.84312 24.774 8.63685 24.774 7.43057C24.774 7.40166 24.7568 7.35897 24.7877 7.34451C24.8282 7.32592 24.8427 7.37343 24.8633 7.39684C24.9814 7.53316 25.0988 7.67018 25.2169 7.8065C25.2636 7.8602 25.3103 7.9146 25.3584 7.96761C25.379 7.98896 25.39 8.01305 25.39 8.04266C25.39 8.07709 25.392 8.11082 25.392 8.14525V14.6531C25.392 14.7901 25.4044 14.7839 25.2595 14.7832Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_121_1869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 7.32591H24.7574V7.37824H25.4043V7.32591Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 7.37756H24.7574V7.49254H25.4043V7.37756Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 7.49255H24.7574V7.60753H25.4043V7.49255Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 7.60754H24.7574V7.72252H25.4043V7.60754Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 7.7225H24.7574V7.83749H25.4043V7.7225Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 7.83679H24.7574V7.95177H25.4043V7.83679Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 7.95178H24.7574V8.06676H25.4043V7.95178Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 8.06676H24.7574V8.18174H25.4043V8.06676Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 8.18105H24.7574V8.29603H25.4043V8.18105Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 8.29604H24.7574V8.41102H25.4043V8.29604Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 8.41101H24.7574V8.52599H25.4043V8.41101Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 8.526H24.7574V8.64098H25.4043V8.526Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 8.6403H24.7574V8.75529H25.4043V8.6403Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 8.75526H24.7574V8.87025H25.4043V8.75526Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 8.87025H24.7574V8.98524H25.4043V8.87025Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 8.98454H24.7574V9.09952H25.4043V8.98454Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 9.09953H24.7574V9.21452H25.4043V9.09953Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 9.21452H24.7574V9.3295H25.4043V9.21452Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 9.32951H24.7574V9.44449H25.4043V9.32951Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 9.44379H24.7574V9.55877H25.4043V9.44379Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 9.55878H24.7574V9.67377H25.4043V9.55878Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 9.67375H24.7574V9.78873H25.4043V9.67375Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 9.78873H24.7574V9.90372H25.4043V9.78873Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 9.90302H24.7574V10.018H25.4043V9.90302Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 10.018H24.7574V10.133H25.4043V10.018Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 10.133H24.7574V10.248H25.4043V10.133Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 10.2473H24.7574V10.3623H25.4043V10.2473Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 10.3623H24.7574V10.4772H25.4043V10.3623Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 10.4772H24.7574V10.5922H25.4043V10.4772Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 10.5922H24.7574V10.7072H25.4043V10.5922Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 10.7065H24.7574V10.8215H25.4043V10.7065Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 10.8215H24.7574V10.9365H25.4043V10.8215Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 10.9365H24.7574V11.0515H25.4043V10.9365Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 11.0508H24.7574V11.1658H25.4043V11.0508Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 11.1658H24.7574V11.2807H25.4043V11.1658Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 11.2807H24.7574V11.3957H25.4043V11.2807Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 11.3957H24.7574V11.5107H25.4043V11.3957Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 11.51H24.7574V11.625H25.4043V11.51Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 11.625H24.7574V11.74H25.4043V11.625Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 11.74H24.7574V11.855H25.4043V11.74Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 11.8543H24.7574V11.9692H25.4043V11.8543Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 11.9693H24.7574V12.0842H25.4043V11.9693Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 12.0842H24.7574V12.1992H25.4043V12.0842Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 12.1992H24.7574V12.3142H25.4043V12.1992Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 12.3135H24.7574V12.4285H25.4043V12.3135Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 12.4285H24.7574V12.5435H25.4043V12.4285Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 12.5435H24.7574V12.6585H25.4043V12.5435Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 12.6578H24.7574V12.7727H25.4043V12.6578Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 12.7728H24.7574V12.8877H25.4043V12.7728Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 12.8877H24.7574V13.0027H25.4043V12.8877Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 13.0027H24.7574V13.1177H25.4043V13.0027Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 13.117H24.7574V13.232H25.4043V13.117Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 13.232H24.7574V13.347H25.4043V13.232Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 13.347H24.7574V13.4619H25.4043V13.347Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 13.4613H24.7574V13.5762H25.4043V13.4613Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 13.5762H24.7574V13.6912H25.4043V13.5762Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 13.6912H24.7574V13.8062H25.4043V13.6912Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 13.8062H24.7574V13.9212H25.4043V13.8062Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 13.9205H24.7574V14.0355H25.4043V13.9205Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 14.0355H24.7574V14.1505H25.4043V14.0355Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 14.1505H24.7574V14.2654H25.4043V14.1505Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 14.2648H24.7574V14.3797H25.4043V14.2648Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 14.3797H24.7574V14.4947H25.4043V14.3797Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 14.4947H24.7574V14.6097H25.4043V14.4947Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 14.6097H24.7574V14.7247H25.4043V14.6097Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 14.724H24.7574V14.7908H25.4043V14.724Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0489 5.42628H23.1141V5.54127H27.0489V5.42628Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 5.54131H23.1143V5.65629H27.049V5.54131Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 5.65629H23.1143V5.77127H27.049V5.65629Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 5.77058H23.1143V5.88556H27.049V5.77058Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 5.88557H23.1143V6.00055H27.049V5.88557Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 6.00053H23.1143V6.11552H27.049V6.00053Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 6.11552H23.1143V6.2305H27.049V6.11552Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 6.22981H23.1143V6.34479H27.049V6.22981Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 6.3448H23.1143V6.45978H27.049V6.3448Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 6.45979H23.1143V6.57477H27.049V6.45979Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 6.57407H23.1143V6.68905H27.049V6.57407Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 6.68904H23.1143V6.80402H27.049V6.68904Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 6.80403H23.1143V6.91901H27.049V6.80403Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 6.91902H23.1143V7.034H27.049V6.91902Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 7.03332H23.1143V7.1483H27.049V7.03332Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 7.14828H23.1143V7.26327H27.049V7.14828Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 7.26328H23.1143V7.37826H27.049V7.26328Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 7.37756H23.1143V7.49254H27.049V7.37756Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 7.49255H23.1143V7.60753H27.049V7.49255Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 7.60754H23.1143V7.72252H27.049V7.60754Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 7.7225H23.1143V7.83749H27.049V7.7225Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 7.83679H23.1143V7.95177H27.049V7.83679Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 7.95178H23.1143V8.06676H27.049V7.95178Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 8.06676H23.1143V8.18174H27.049V8.06676Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 8.18105H23.1143V8.29603H27.049V8.18105Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 8.29604H23.1143V8.41102H27.049V8.29604Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 8.41101H23.1143V8.52599H27.049V8.41101Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 8.526H23.1143V8.64098H27.049V8.526Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 8.6403H23.1143V8.75529H27.049V8.6403Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 8.75526H23.1143V8.87025H27.049V8.75526Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 8.87025H23.1143V8.98524H27.049V8.87025Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 8.98454H23.1143V9.09952H27.049V8.98454Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 9.09953H23.1143V9.21452H27.049V9.09953Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 9.21452H23.1143V9.3295H27.049V9.21452Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 9.32951H23.1143V9.44449H27.049V9.32951Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 9.44379H23.1143V9.55877H27.049V9.44379Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 9.55878H23.1143V9.67377H27.049V9.55878Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 9.67375H23.1143V9.78873H27.049V9.67375Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 9.78873H23.1143V9.90372H27.049V9.78873Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 9.90302H23.1143V10.018H27.049V9.90302Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 10.018H23.1143V10.133H27.049V10.018Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 10.133H23.1143V10.248H27.049V10.133Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 10.2473H23.1143V10.3623H27.049V10.2473Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 10.3623H23.1143V10.4772H27.049V10.3623Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 10.4772H23.1143V10.5922H27.049V10.4772Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 10.5922H23.1143V10.7072H27.049V10.5922Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 10.7065H23.1143V10.8215H27.049V10.7065Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 10.8215H23.1143V10.9365H27.049V10.8215Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 10.9365H23.1143V11.0515H27.049V10.9365Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 11.0508H23.1143V11.1658H27.049V11.0508Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 11.1658H23.1143V11.2807H27.049V11.1658Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 11.2807H23.1143V11.3957H27.049V11.2807Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 11.3957H23.1143V11.5107H27.049V11.3957Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 11.51H23.1143V11.625H27.049V11.51Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 11.625H23.1143V11.74H27.049V11.625Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 11.74H23.1143V11.855H27.049V11.74Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 11.8543H23.1143V11.9692H27.049V11.8543Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 11.9693H23.1143V12.0842H27.049V11.9693Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 12.0842H23.1143V12.1992H27.049V12.0842Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 12.1992H23.1143V12.3142H27.049V12.1992Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 12.3135H23.1143V12.4285H27.049V12.3135Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 12.4285H23.1143V12.5435H27.049V12.4285Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 12.5435H23.1143V12.6585H27.049V12.5435Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 12.6578H23.1143V12.7727H27.049V12.6578Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 12.7728H23.1143V12.8877H27.049V12.7728Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 12.8877H23.1143V13.0027H27.049V12.8877Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 13.0027H23.1143V13.1177H27.049V13.0027Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 13.117H23.1143V13.232H27.049V13.117Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 13.232H23.1143V13.347H27.049V13.232Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 13.347H23.1143V13.4619H27.049V13.347Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 13.4613H23.1143V13.5762H27.049V13.4613Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 13.5762H23.1143V13.6912H27.049V13.5762Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 13.6912H23.1143V13.8062H27.049V13.6912Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 13.8062H23.1143V13.9212H27.049V13.8062Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 13.9205H23.1143V14.0355H27.049V13.9205Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 14.0355H23.1143V14.1505H27.049V14.0355Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 14.1505H23.1143V14.2654H27.049V14.1505Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 14.2648H23.1143V14.3797H27.049V14.2648Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 14.3797H23.1143V14.4947H27.049V14.3797Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 14.4947H23.1143V14.6097H27.049V14.4947Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 14.6097H23.1143V14.7247H27.049V14.6097Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 14.724H23.1143V14.839H27.049V14.724Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 14.839H23.1143V14.9539H27.049V14.839Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 14.9539H23.1143V15.0689H27.049V14.9539Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 15.0689H23.1143V15.1839H27.049V15.0689Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 15.1832H23.1143V15.2982H27.049V15.1832Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 15.2982H23.1143V15.4132H27.049V15.2982Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 15.4132H23.1143V15.5282H27.049V15.4132Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 15.5275H23.1143V15.6425H27.049V15.5275Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 15.6425H23.1143V15.7574H27.049V15.6425Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 15.7574H23.1143V15.8724H27.049V15.7574Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 15.8724H23.1143V15.9874H27.049V15.8724Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 15.9867H23.1143V16.1017H27.049V15.9867Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 16.1017H23.1143V16.2167H27.049V16.1017Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 16.2167H23.1143V16.3317H27.049V16.2167Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 16.331H23.1143V16.446H27.049V16.331Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 16.446H23.1143V16.5609H27.049V16.446Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 16.5609H23.1143V16.6759H27.049V16.5609Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 16.6759H23.1143V16.7909H27.049V16.6759Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 16.7902H23.1143V16.9052H27.049V16.7902Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 16.9052H23.1143V17.0202H27.049V16.9052Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 17.0202H23.1143V17.1352H27.049V17.0202Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 17.1345H23.1143V17.2494H27.049V17.1345Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 17.2495H23.1143V17.3644H27.049V17.2495Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 17.3644H23.1143V17.4794H27.049V17.3644Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 17.4794H23.1143V17.5944H27.049V17.4794Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 17.5937H23.1143V17.7087H27.049V17.5937Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 17.7087H23.1143V17.8237H27.049V17.7087Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 17.8237H23.1143V17.9387H27.049V17.8237Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 17.938H23.1143V18.053H27.049V17.938Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 18.0529H23.1143V18.1679H27.049V18.0529Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 18.1679H23.1143V18.2829H27.049V18.1679Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 18.2829H23.1143V18.3979H27.049V18.2829Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 18.3972H23.1143V18.5122H27.049V18.3972Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 18.5122H23.1143V18.6272H27.049V18.5122Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 18.6272H23.1143V18.7421H27.049V18.6272Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 18.7415H23.1143V18.8564H27.049V18.7415Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 18.8564H23.1143V18.9714H27.049V18.8564Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 18.9714H23.1143V19.0864H27.049V18.9714Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 19.0864H23.1143V19.2014H27.049V19.0864Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 19.2007H23.1143V19.3157H27.049V19.2007Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 19.3157H23.1143V19.4307H27.049V19.3157Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 19.4307H23.1143V19.5456H27.049V19.4307Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 19.545H23.1143V19.6599H27.049V19.545Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 19.6599H23.1143V19.7749H27.049V19.6599Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 19.7749H23.1143V19.8899H27.049V19.7749Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 19.8899H23.1143V20.0049H27.049V19.8899Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 20.0042H23.1143V20.1192H27.049V20.0042Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 20.1192H23.1143V20.2342H27.049V20.1192Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 20.2341H23.1143V20.3491H27.049V20.2341Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 20.3491H23.1143V20.4641H27.049V20.3491Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 20.4634H23.1143V20.5784H27.049V20.4634Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 20.5784H23.1143V20.6934H27.049V20.5784Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 20.6934H23.1143V20.8084H27.049V20.6934Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 20.8077H23.1143V20.9227H27.049V20.8077Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 20.9227H23.1143V21.0377H27.049V20.9227Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 21.0376H23.1143V21.1526H27.049V21.0376Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 21.1526H23.1143V21.2676H27.049V21.1526Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 21.2669H23.1143V21.3819H27.049V21.2669Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 21.3819H23.1143V21.4969H27.049V21.3819Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 21.4969H23.1143V21.6119H27.049V21.4969Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 21.6112H23.1143V21.7262H27.049V21.6112Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 21.7262H23.1143V21.8411H27.049V21.7262Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 21.8411H23.1143V21.9561H27.049V21.8411Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 21.9561H23.1143V22.0711H27.049V21.9561Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 22.0704H23.1143V22.1854H27.049V22.0704Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 22.1854H23.1143V22.3004H27.049V22.1854Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 22.3004H23.1143V22.4153H27.049V22.3004Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 22.4147H23.1143V22.5297H27.049V22.4147Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 22.5296H23.1143V22.6446H27.049V22.5296Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 22.6446H23.1143V22.7596H27.049V22.6446Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 22.7596H23.1143V22.8746H27.049V22.7596Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 22.8739H23.1143V22.9889H27.049V22.8739Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 22.9889H23.1143V23.1039H27.049V22.9889Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 23.1039H23.1143V23.2188H27.049V23.1039Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 23.2182H23.1143V23.3332H27.049V23.2182Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 23.3331H23.1143V23.4481H27.049V23.3331Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 23.4481H23.1143V23.5631H27.049V23.4481Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 23.5631H23.1143V23.6781H27.049V23.5631Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 23.6774H23.1143V23.7924H27.049V23.6774Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 23.7924H23.1143V23.9074H27.049V23.7924Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 23.9074H23.1143V24.0223H27.049V23.9074Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 24.0217H23.1143V24.1366H27.049V24.0217Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 24.1366H23.1143V24.2516H27.049V24.1366Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 24.2516H23.1143V24.3666H27.049V24.2516Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 24.3666H23.1143V24.4816H27.049V24.3666Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 24.4809H23.1143V24.5959H27.049V24.4809Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 24.5959H23.1143V24.7109H27.049V24.5959Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 24.7109H23.1143V24.8258H27.049V24.7109Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 24.8259H23.1143V24.9408H27.049V24.8259Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 24.9401H23.1143V25.0551H27.049V24.9401Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 25.0551H23.1143V25.1701H27.049V25.0551Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 25.1701H23.1143V25.2851H27.049V25.1701Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 25.2844H23.1143V25.3994H27.049V25.2844Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 25.3994H23.1143V25.5144H27.049V25.3994Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 25.5144H23.1143V25.6293H27.049V25.5144Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 25.6293H23.1143V25.7443H27.049V25.6293Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 25.7436H23.1143V25.8586H27.049V25.7436Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 25.8586H23.1143V25.9736H27.049V25.8586Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 25.9736H23.1143V26.0886H27.049V25.9736Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 26.0879H23.1143V26.2029H27.049V26.0879Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 26.2029H23.1143V26.3178H27.049V26.2029Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 26.3179H23.1143V26.4328H27.049V26.3179Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049 26.4328H23.1143V26.5478H27.049V26.4328Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_121_1869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 10,
    width: 5,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5729 24.8024C31.5516 23.9742 31.5674 23.1445 31.5674 22.3155C31.5674 19.0341 31.5674 15.7526 31.5688 12.4712C31.5688 12.4264 31.5564 12.3954 31.5235 12.3665C31.3655 12.2309 31.2089 12.0932 31.051 11.9575C30.4879 11.4728 29.9241 10.9888 29.3617 10.5034C29.3288 10.4752 29.2972 10.4614 29.2533 10.4614C28.7492 10.4628 28.2459 10.4614 27.7425 10.4628C27.6691 10.4628 27.6691 10.4649 27.667 10.5344C27.667 10.5475 27.667 10.5599 27.667 10.5716V26.4459C27.667 26.5719 27.656 26.563 27.781 26.563H31.4658C31.4843 26.563 31.5029 26.563 31.5221 26.563C31.5859 26.5602 31.5866 26.5602 31.5887 26.4914C31.5887 26.4728 31.5887 26.4542 31.5887 26.4349C31.5784 25.8903 31.5887 25.3464 31.5743 24.8017L31.5729 24.8024ZM29.9255 12.5483V24.7935C29.9255 24.925 29.9344 24.916 29.806 24.916C29.6632 24.916 29.5204 24.916 29.3769 24.916C29.313 24.916 29.3096 24.9105 29.3068 24.8465C29.3068 24.8307 29.3068 24.8148 29.3068 24.7997V18.3965C29.3068 16.2656 29.3068 14.1339 29.3068 12.003C29.3068 11.9706 29.2876 11.9259 29.3219 11.908C29.359 11.8894 29.3782 11.9362 29.4029 11.9562C29.5629 12.0897 29.7209 12.2254 29.8809 12.3583C29.9125 12.3844 29.929 12.4133 29.9255 12.4547C29.9235 12.4856 29.9255 12.5166 29.9255 12.5483Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_121_1869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 11.8887H29.2876V11.9486H29.9338V11.8887Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 11.9486H29.2876V12.036H29.9338V11.9486Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 12.036H29.2876V12.1235H29.9338V12.036Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 12.1235H29.2876V12.2109H29.9338V12.1235Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 12.2109H29.2876V12.2984H29.9338V12.2109Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 12.2984H29.2876V12.3858H29.9338V12.2984Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 12.3858H29.2876V12.4732H29.9338V12.3858Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 12.4739H29.2876V12.5614H29.9338V12.4739Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 12.5614H29.2876V12.6488H29.9338V12.5614Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 12.6488H29.2876V12.7363H29.9338V12.6488Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 12.7363H29.2876V12.8237H29.9338V12.7363Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 12.8237H29.2876V12.9111H29.9338V12.8237Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 12.9111H29.2876V12.9986H29.9338V12.9111Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 12.9986H29.2876V13.086H29.9338V12.9986Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 13.086H29.2876V13.1735H29.9338V13.086Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 13.1735H29.2876V13.2609H29.9338V13.1735Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 13.2616H29.2876V13.349H29.9338V13.2616Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 13.349H29.2876V13.4365H29.9338V13.349Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 13.4365H29.2876V13.5239H29.9338V13.4365Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 13.5239H29.2876V13.6114H29.9338V13.5239Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 13.6114H29.2876V13.6988H29.9338V13.6114Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 13.6988H29.2876V13.7862H29.9338V13.6988Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 13.7862H29.2876V13.8737H29.9338V13.7862Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 13.8737H29.2876V13.9611H29.9338V13.8737Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 13.9611H29.2876V14.0486H29.9338V13.9611Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 14.0486H29.2876V14.136H29.9338V14.0486Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 14.1367H29.2876V14.2241H29.9338V14.1367Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 14.2241H29.2876V14.3116H29.9338V14.2241Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 14.3116H29.2876V14.399H29.9338V14.3116Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 14.399H29.2876V14.4864H29.9338V14.399Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 14.4865H29.2876V14.5739H29.9338V14.4865Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 14.5739H29.2876V14.6613H29.9338V14.5739Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 14.6613H29.2876V14.7488H29.9338V14.6613Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 14.7488H29.2876V14.8362H29.9338V14.7488Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 14.8362H29.2876V14.9237H29.9338V14.8362Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 14.9237H29.2876V15.0111H29.9338V14.9237Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 15.0118H29.2876V15.0992H29.9338V15.0118Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 15.0992H29.2876V15.1867H29.9338V15.0992Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 15.1867H29.2876V15.2741H29.9338V15.1867Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 15.2741H29.2876V15.3615H29.9338V15.2741Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 15.3616H29.2876V15.449H29.9338V15.3616Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 15.449H29.2876V15.5364H29.9338V15.449Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 15.5364H29.2876V15.6239H29.9338V15.5364Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 15.6239H29.2876V15.7113H29.9338V15.6239Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 15.7113H29.2876V15.7988H29.9338V15.7113Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 15.7988H29.2876V15.8862H29.9338V15.7988Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 15.8869H29.2876V15.9743H29.9338V15.8869Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 15.9743H29.2876V16.0618H29.9338V15.9743Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 16.0618H29.2876V16.1492H29.9338V16.0618Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 16.1492H29.2876V16.2367H29.9338V16.1492Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 16.2367H29.2876V16.3241H29.9338V16.2367Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 16.3241H29.2876V16.4115H29.9338V16.3241Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 16.4115H29.2876V16.499H29.9338V16.4115Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 16.499H29.2876V16.5864H29.9338V16.499Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 16.5864H29.2876V16.6739H29.9338V16.5864Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 16.6739H29.2876V16.7613H29.9338V16.6739Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 16.762H29.2876V16.8494H29.9338V16.762Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 16.8494H29.2876V16.9369H29.9338V16.8494Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 16.9369H29.2876V17.0243H29.9338V16.9369Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 17.0243H29.2876V17.1118H29.9338V17.0243Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 17.1118H29.2876V17.1992H29.9338V17.1118Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 17.1992H29.2876V17.2866H29.9338V17.1992Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 17.2866H29.2876V17.3741H29.9338V17.2866Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 17.3741H29.2876V17.4615H29.9338V17.3741Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 17.4615H29.2876V17.549H29.9338V17.4615Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 17.5497H29.2876V17.6371H29.9338V17.5497Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 17.6371H29.2876V17.7245H29.9338V17.6371Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 17.7245H29.2876V17.812H29.9338V17.7245Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 17.812H29.2876V17.8994H29.9338V17.812Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 17.8994H29.2876V17.9869H29.9338V17.8994Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 17.9868H29.2876V18.0743H29.9338V17.9868Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 18.0743H29.2876V18.1617H29.9338V18.0743Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 18.1617H29.2876V18.2492H29.9338V18.1617Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 18.2492H29.2876V18.3366H29.9338V18.2492Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 18.3366H29.2876V18.4241H29.9338V18.3366Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 18.4247H29.2876V18.5122H29.9338V18.4247Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 18.5122H29.2876V18.5996H29.9338V18.5122Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 18.5996H29.2876V18.6871H29.9338V18.5996Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 18.6871H29.2876V18.7745H29.9338V18.6871Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 18.7745H29.2876V18.862H29.9338V18.7745Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 18.862H29.2876V18.9494H29.9338V18.862Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 18.9494H29.2876V19.0368H29.9338V18.9494Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 19.0368H29.2876V19.1243H29.9338V19.0368Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 19.1243H29.2876V19.2117H29.9338V19.1243Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 19.2117H29.2876V19.2992H29.9338V19.2117Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 19.2999H29.2876V19.3873H29.9338V19.2999Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 19.3873H29.2876V19.4747H29.9338V19.3873Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 19.4747H29.2876V19.5622H29.9338V19.4747Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 19.5622H29.2876V19.6496H29.9338V19.5622Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 19.6496H29.2876V19.7371H29.9338V19.6496Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 19.737H29.2876V19.8245H29.9338V19.737Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 19.8245H29.2876V19.9119H29.9338V19.8245Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 19.9119H29.2876V19.9994H29.9338V19.9119Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 19.9994H29.2876V20.0868H29.9338V19.9994Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 20.0868H29.2876V20.1743H29.9338V20.0868Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 20.1749H29.2876V20.2624H29.9338V20.1749Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 20.2624H29.2876V20.3498H29.9338V20.2624Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 20.3498H29.2876V20.4373H29.9338V20.3498Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 20.4373H29.2876V20.5247H29.9338V20.4373Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 20.5247H29.2876V20.6122H29.9338V20.5247Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 20.6122H29.2876V20.6996H29.9338V20.6122Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 20.6996H29.2876V20.787H29.9338V20.6996Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 20.787H29.2876V20.8745H29.9338V20.787Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 20.8745H29.2876V20.9619H29.9338V20.8745Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 20.9626H29.2876V21.0501H29.9338V20.9626Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 21.05H29.2876V21.1375H29.9338V21.05Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 21.1375H29.2876V21.2249H29.9338V21.1375Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 21.2249H29.2876V21.3124H29.9338V21.2249Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 21.3124H29.2876V21.3998H29.9338V21.3124Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 21.3998H29.2876V21.4873H29.9338V21.3998Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 21.4873H29.2876V21.5747H29.9338V21.4873Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 21.5747H29.2876V21.6621H29.9338V21.5747Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 21.6621H29.2876V21.7496H29.9338V21.6621Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 21.7496H29.2876V21.837H29.9338V21.7496Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 21.8377H29.2876V21.9251H29.9338V21.8377Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 21.9251H29.2876V22.0126H29.9338V21.9251Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 22.0126H29.2876V22.1H29.9338V22.0126Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 22.1H29.2876V22.1875H29.9338V22.1Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 22.1875H29.2876V22.2749H29.9338V22.1875Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 22.2749H29.2876V22.3624H29.9338V22.2749Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 22.3624H29.2876V22.4498H29.9338V22.3624Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 22.4498H29.2876V22.5372H29.9338V22.4498Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 22.5372H29.2876V22.6247H29.9338V22.5372Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 22.6247H29.2876V22.7121H29.9338V22.6247Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 22.7128H29.2876V22.8002H29.9338V22.7128Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 22.8002H29.2876V22.8877H29.9338V22.8002Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 22.8877H29.2876V22.9751H29.9338V22.8877Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 22.9751H29.2876V23.0626H29.9338V22.9751Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 23.0626H29.2876V23.15H29.9338V23.0626Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 23.15H29.2876V23.2374H29.9338V23.15Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 23.2375H29.2876V23.3249H29.9338V23.2375Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 23.3249H29.2876V23.4123H29.9338V23.3249Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 23.4123H29.2876V23.4998H29.9338V23.4123Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 23.4998H29.2876V23.5872H29.9338V23.4998Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 23.5879H29.2876V23.6753H29.9338V23.5879Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 23.6754H29.2876V23.7628H29.9338V23.6754Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 23.7628H29.2876V23.8502H29.9338V23.7628Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 23.8502H29.2876V23.9377H29.9338V23.8502Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 23.9377H29.2876V24.0251H29.9338V23.9377Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 24.0251H29.2876V24.1125H29.9338V24.0251Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 24.1125H29.2876V24.2H29.9338V24.1125Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 24.2H29.2876V24.2874H29.9338V24.2Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 24.2874H29.2876V24.3749H29.9338V24.2874Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 24.3756H29.2876V24.463H29.9338V24.3756Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 24.463H29.2876V24.5504H29.9338V24.463Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 24.5504H29.2876V24.6379H29.9338V24.5504Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 24.6379H29.2876V24.7253H29.9338V24.6379Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 24.7253H29.2876V24.8128H29.9338V24.7253Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 24.8128H29.2876V24.9002H29.9338V24.8128Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9338 24.9002H29.2876V24.925H29.9338V24.9002Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5879 10.4607H27.6559V10.5482H31.5879V10.4607Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 10.5482H27.656V10.6356H31.588V10.5482Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 10.6356H27.656V10.723H31.588V10.6356Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 10.7237H27.656V10.8112H31.588V10.7237Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 10.8112H27.656V10.8986H31.588V10.8112Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 10.8986H27.656V10.9861H31.588V10.8986Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 10.9861H27.656V11.0735H31.588V10.9861Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 11.0735H27.656V11.1609H31.588V11.0735Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 11.1609H27.656V11.2484H31.588V11.1609Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 11.2484H27.656V11.3358H31.588V11.2484Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 11.3358H27.656V11.4233H31.588V11.3358Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 11.4233H27.656V11.5107H31.588V11.4233Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 11.5107H27.656V11.5982H31.588V11.5107Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 11.5988H27.656V11.6863H31.588V11.5988Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 11.6863H27.656V11.7737H31.588V11.6863Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 11.7737H27.656V11.8612H31.588V11.7737Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 11.8612H27.656V11.9486H31.588V11.8612Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 11.9486H27.656V12.036H31.588V11.9486Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 12.036H27.656V12.1235H31.588V12.036Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 12.1235H27.656V12.2109H31.588V12.1235Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 12.2109H27.656V12.2984H31.588V12.2109Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 12.2984H27.656V12.3858H31.588V12.2984Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 12.3858H27.656V12.4732H31.588V12.3858Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 12.4739H27.656V12.5614H31.588V12.4739Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 12.5614H27.656V12.6488H31.588V12.5614Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 12.6488H27.656V12.7363H31.588V12.6488Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 12.7363H27.656V12.8237H31.588V12.7363Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 12.8237H27.656V12.9111H31.588V12.8237Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 12.9111H27.656V12.9986H31.588V12.9111Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 12.9986H27.656V13.086H31.588V12.9986Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 13.086H27.656V13.1735H31.588V13.086Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 13.1735H27.656V13.2609H31.588V13.1735Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 13.2616H27.656V13.349H31.588V13.2616Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 13.349H27.656V13.4365H31.588V13.349Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 13.4365H27.656V13.5239H31.588V13.4365Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 13.5239H27.656V13.6114H31.588V13.5239Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 13.6114H27.656V13.6988H31.588V13.6114Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 13.6988H27.656V13.7862H31.588V13.6988Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 13.7862H27.656V13.8737H31.588V13.7862Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 13.8737H27.656V13.9611H31.588V13.8737Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 13.9611H27.656V14.0486H31.588V13.9611Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 14.0486H27.656V14.136H31.588V14.0486Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 14.1367H27.656V14.2241H31.588V14.1367Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 14.2241H27.656V14.3116H31.588V14.2241Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 14.3116H27.656V14.399H31.588V14.3116Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 14.399H27.656V14.4864H31.588V14.399Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 14.4865H27.656V14.5739H31.588V14.4865Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 14.5739H27.656V14.6613H31.588V14.5739Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 14.6613H27.656V14.7488H31.588V14.6613Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 14.7488H27.656V14.8362H31.588V14.7488Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 14.8362H27.656V14.9237H31.588V14.8362Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 14.9237H27.656V15.0111H31.588V14.9237Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 15.0118H27.656V15.0992H31.588V15.0118Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 15.0992H27.656V15.1867H31.588V15.0992Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 15.1867H27.656V15.2741H31.588V15.1867Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 15.2741H27.656V15.3615H31.588V15.2741Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 15.3616H27.656V15.449H31.588V15.3616Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 15.449H27.656V15.5364H31.588V15.449Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 15.5364H27.656V15.6239H31.588V15.5364Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 15.6239H27.656V15.7113H31.588V15.6239Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 15.7113H27.656V15.7988H31.588V15.7113Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 15.7988H27.656V15.8862H31.588V15.7988Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 15.8869H27.656V15.9743H31.588V15.8869Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 15.9743H27.656V16.0618H31.588V15.9743Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 16.0618H27.656V16.1492H31.588V16.0618Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 16.1492H27.656V16.2367H31.588V16.1492Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 16.2367H27.656V16.3241H31.588V16.2367Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 16.3241H27.656V16.4115H31.588V16.3241Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 16.4115H27.656V16.499H31.588V16.4115Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 16.499H27.656V16.5864H31.588V16.499Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 16.5864H27.656V16.6739H31.588V16.5864Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 16.6739H27.656V16.7613H31.588V16.6739Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 16.762H27.656V16.8494H31.588V16.762Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 16.8494H27.656V16.9369H31.588V16.8494Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 16.9369H27.656V17.0243H31.588V16.9369Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 17.0243H27.656V17.1118H31.588V17.0243Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 17.1118H27.656V17.1992H31.588V17.1118Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 17.1992H27.656V17.2866H31.588V17.1992Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 17.2866H27.656V17.3741H31.588V17.2866Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 17.3741H27.656V17.4615H31.588V17.3741Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 17.4615H27.656V17.549H31.588V17.4615Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 17.5497H27.656V17.6371H31.588V17.5497Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 17.6371H27.656V17.7245H31.588V17.6371Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 17.7245H27.656V17.812H31.588V17.7245Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 17.812H27.656V17.8994H31.588V17.812Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 17.8994H27.656V17.9869H31.588V17.8994Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 17.9868H27.656V18.0743H31.588V17.9868Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 18.0743H27.656V18.1617H31.588V18.0743Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 18.1617H27.656V18.2492H31.588V18.1617Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 18.2492H27.656V18.3366H31.588V18.2492Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 18.3366H27.656V18.4241H31.588V18.3366Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 18.4247H27.656V18.5122H31.588V18.4247Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 18.5122H27.656V18.5996H31.588V18.5122Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 18.5996H27.656V18.6871H31.588V18.5996Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 18.6871H27.656V18.7745H31.588V18.6871Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 18.7745H27.656V18.862H31.588V18.7745Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 18.862H27.656V18.9494H31.588V18.862Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 18.9494H27.656V19.0368H31.588V18.9494Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 19.0368H27.656V19.1243H31.588V19.0368Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 19.1243H27.656V19.2117H31.588V19.1243Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 19.2117H27.656V19.2992H31.588V19.2117Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 19.2999H27.656V19.3873H31.588V19.2999Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 19.3873H27.656V19.4747H31.588V19.3873Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 19.4747H27.656V19.5622H31.588V19.4747Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 19.5622H27.656V19.6496H31.588V19.5622Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 19.6496H27.656V19.7371H31.588V19.6496Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 19.737H27.656V19.8245H31.588V19.737Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 19.8245H27.656V19.9119H31.588V19.8245Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 19.9119H27.656V19.9994H31.588V19.9119Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 19.9994H27.656V20.0868H31.588V19.9994Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 20.0868H27.656V20.1743H31.588V20.0868Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 20.1749H27.656V20.2624H31.588V20.1749Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 20.2624H27.656V20.3498H31.588V20.2624Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 20.3498H27.656V20.4373H31.588V20.3498Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 20.4373H27.656V20.5247H31.588V20.4373Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 20.5247H27.656V20.6122H31.588V20.5247Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 20.6122H27.656V20.6996H31.588V20.6122Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 20.6996H27.656V20.787H31.588V20.6996Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 20.787H27.656V20.8745H31.588V20.787Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 20.8745H27.656V20.9619H31.588V20.8745Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 20.9626H27.656V21.0501H31.588V20.9626Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 21.05H27.656V21.1375H31.588V21.05Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 21.1375H27.656V21.2249H31.588V21.1375Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 21.2249H27.656V21.3124H31.588V21.2249Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 21.3124H27.656V21.3998H31.588V21.3124Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 21.3998H27.656V21.4873H31.588V21.3998Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 21.4873H27.656V21.5747H31.588V21.4873Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 21.5747H27.656V21.6621H31.588V21.5747Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 21.6621H27.656V21.7496H31.588V21.6621Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 21.7496H27.656V21.837H31.588V21.7496Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 21.8377H27.656V21.9251H31.588V21.8377Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 21.9251H27.656V22.0126H31.588V21.9251Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 22.0126H27.656V22.1H31.588V22.0126Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 22.1H27.656V22.1875H31.588V22.1Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 22.1875H27.656V22.2749H31.588V22.1875Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 22.2749H27.656V22.3624H31.588V22.2749Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 22.3624H27.656V22.4498H31.588V22.3624Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 22.4498H27.656V22.5372H31.588V22.4498Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 22.5372H27.656V22.6247H31.588V22.5372Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 22.6247H27.656V22.7121H31.588V22.6247Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 22.7128H27.656V22.8002H31.588V22.7128Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 22.8002H27.656V22.8877H31.588V22.8002Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 22.8877H27.656V22.9751H31.588V22.8877Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 22.9751H27.656V23.0626H31.588V22.9751Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 23.0626H27.656V23.15H31.588V23.0626Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 23.15H27.656V23.2374H31.588V23.15Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 23.2375H27.656V23.3249H31.588V23.2375Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 23.3249H27.656V23.4123H31.588V23.3249Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 23.4123H27.656V23.4998H31.588V23.4123Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 23.4998H27.656V23.5872H31.588V23.4998Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 23.5879H27.656V23.6753H31.588V23.5879Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 23.6754H27.656V23.7628H31.588V23.6754Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 23.7628H27.656V23.8502H31.588V23.7628Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 23.8502H27.656V23.9377H31.588V23.8502Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 23.9377H27.656V24.0251H31.588V23.9377Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 24.0251H27.656V24.1125H31.588V24.0251Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 24.1125H27.656V24.2H31.588V24.1125Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 24.2H27.656V24.2874H31.588V24.2Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 24.2874H27.656V24.3749H31.588V24.2874Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 24.3756H27.656V24.463H31.588V24.3756Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 24.463H27.656V24.5504H31.588V24.463Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 24.5504H27.656V24.6379H31.588V24.5504Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 24.6379H27.656V24.7253H31.588V24.6379Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 24.7253H27.656V24.8128H31.588V24.7253Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 24.8128H27.656V24.9002H31.588V24.8128Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 24.9002H27.656V24.9876H31.588V24.9002Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 24.9877H27.656V25.0751H31.588V24.9877Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 25.0751H27.656V25.1625H31.588V25.0751Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 25.1625H27.656V25.25H31.588V25.1625Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 25.2507H27.656V25.3381H31.588V25.2507Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 25.3381H27.656V25.4255H31.588V25.3381Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 25.4256H27.656V25.513H31.588V25.4256Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 25.513H27.656V25.6004H31.588V25.513Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 25.6004H27.656V25.6879H31.588V25.6004Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 25.6879H27.656V25.7753H31.588V25.6879Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 25.7753H27.656V25.8627H31.588V25.7753Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 25.8627H27.656V25.9502H31.588V25.8627Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 25.9502H27.656V26.0376H31.588V25.9502Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 26.0376H27.656V26.1251H31.588V26.0376Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 26.1258H27.656V26.2132H31.588V26.1258Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 26.2132H27.656V26.3007H31.588V26.2132Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 26.3006H27.656V26.3881H31.588V26.3006Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 26.3881H27.656V26.4755H31.588V26.3881Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 26.4755H27.656V26.563H31.588V26.4755Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.588 26.563H27.656V26.5719H31.588V26.563Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_121_1869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 5,
    height: 17
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0512 11.888C13.9853 11.9217 13.9414 11.9748 13.8906 12.0174C13.7546 12.1311 13.6227 12.2495 13.4882 12.3645C13.4524 12.3948 13.4339 12.4278 13.4353 12.4767C13.438 12.5889 13.436 12.7011 13.436 12.8134C13.436 14.2654 13.436 15.7182 13.436 17.1703C13.436 17.2846 13.4243 17.2853 13.5548 17.2853C14.2298 17.2853 14.9041 17.2853 15.5791 17.2853C15.5977 17.2853 15.6162 17.2853 15.6347 17.2853C15.7048 17.2873 15.7048 17.2873 15.7062 17.3603C15.7069 17.4009 15.7062 17.4415 15.7062 17.4822C15.7062 20.4614 15.7062 23.4412 15.7062 26.4204C15.7062 26.554 15.7247 26.5464 15.5819 26.5464C15.1156 26.5464 14.6493 26.5464 14.1824 26.5464C14.1577 26.5464 14.133 26.5464 14.1075 26.5464C14.0766 26.5464 14.0622 26.5313 14.0629 26.5003C14.0629 26.4783 14.0629 26.4569 14.0629 26.4349C14.0629 23.9762 14.0629 21.5169 14.0629 19.0582C14.0629 18.9239 14.0739 18.9322 13.9366 18.9322C13.7965 18.9322 13.6564 18.9315 13.517 18.9322C13.4449 18.9322 13.438 18.9404 13.436 19.0134C13.4353 19.0478 13.436 19.0823 13.436 19.116C13.436 20.8242 13.436 22.5317 13.436 24.2399C13.436 24.2434 13.436 24.2461 13.436 24.2496C13.436 24.3521 13.436 24.3521 13.3343 24.3521C12.8585 24.3521 12.3826 24.3521 11.9074 24.3521C11.8888 24.3521 11.8703 24.3521 11.8518 24.3521C11.8215 24.3521 11.8058 24.3377 11.8058 24.3067C11.8058 24.2881 11.8058 24.2695 11.8058 24.2509C11.8058 20.3333 11.8058 16.4157 11.8044 12.498C11.8044 12.4312 11.8277 12.3892 11.8758 12.3472C12.2947 11.9851 12.7122 11.6216 13.1297 11.2587C13.416 11.0095 13.7031 10.7616 13.9881 10.511C14.0451 10.4607 14.1027 10.4387 14.1803 10.4394C14.65 10.4428 15.119 10.4414 15.5887 10.4414C15.6107 10.4414 15.632 10.4414 15.654 10.4414C15.6876 10.4408 15.7069 10.4545 15.7062 10.4903C15.7062 10.5124 15.7062 10.5337 15.7062 10.5557C15.7062 12.5751 15.7062 14.5945 15.7062 16.6146C15.7062 16.6305 15.7048 16.6456 15.7062 16.6615C15.7103 16.7048 15.6924 16.7248 15.6478 16.7227C15.6045 16.7207 15.5606 16.7227 15.5173 16.7227C15.073 16.7227 14.6281 16.7227 14.1838 16.7227C14.1618 16.7227 14.1405 16.7221 14.1185 16.7227C14.0801 16.7248 14.0602 16.7083 14.0629 16.6683C14.0643 16.6498 14.0629 16.6312 14.0629 16.6126C14.0629 15.0696 14.0629 13.5274 14.0629 11.9844C14.0629 11.9548 14.0691 11.9231 14.0512 11.8894V11.888Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_121_1869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7242 10.4397H11.8032V10.5271H15.7242V10.4397Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 10.5268H11.8031V10.6143H15.7241V10.5268Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 10.6143H11.8031V10.7017H15.7241V10.6143Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 10.7017H11.8031V10.7891H15.7241V10.7017Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 10.7891H11.8031V10.8766H15.7241V10.7891Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 10.8773H11.8031V10.9647H15.7241V10.8773Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 10.9647H11.8031V11.0522H15.7241V10.9647Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 11.0522H11.8031V11.1396H15.7241V11.0522Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 11.1396H11.8031V11.227H15.7241V11.1396Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 11.227H11.8031V11.3145H15.7241V11.227Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 11.3145H11.8031V11.4019H15.7241V11.3145Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 11.4019H11.8031V11.4894H15.7241V11.4019Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 11.4901H11.8031V11.5775H15.7241V11.4901Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 11.5775H11.8031V11.6649H15.7241V11.5775Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 11.6649H11.8031V11.7524H15.7241V11.6649Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 11.7524H11.8031V11.8398H15.7241V11.7524Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 11.8398H11.8031V11.9273H15.7241V11.8398Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 11.9273H11.8031V12.0147H15.7241V11.9273Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 12.0147H11.8031V12.1021H15.7241V12.0147Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 12.1028H11.8031V12.1903H15.7241V12.1028Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 12.1903H11.8031V12.2777H15.7241V12.1903Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 12.2777H11.8031V12.3651H15.7241V12.2777Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 12.3651H11.8031V12.4526H15.7241V12.3651Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 12.4526H11.8031V12.54H15.7241V12.4526Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 12.54H11.8031V12.6275H15.7241V12.54Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 12.6275H11.8031V12.7149H15.7241V12.6275Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 12.7156H11.8031V12.803H15.7241V12.7156Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 12.803H11.8031V12.8905H15.7241V12.803Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 12.8905H11.8031V12.9779H15.7241V12.8905Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 12.9779H11.8031V13.0654H15.7241V12.9779Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 13.0654H11.8031V13.1528H15.7241V13.0654Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 13.1528H11.8031V13.2402H15.7241V13.1528Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 13.2409H11.8031V13.3284H15.7241V13.2409Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 13.3284H11.8031V13.4158H15.7241V13.3284Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 13.4158H11.8031V13.5033H15.7241V13.4158Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 13.5033H11.8031V13.5907H15.7241V13.5033Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 13.5907H11.8031V13.6781H15.7241V13.5907Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 13.6781H11.8031V13.7656H15.7241V13.6781Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 13.7656H11.8031V13.853H15.7241V13.7656Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 13.8537H11.8031V13.9412H15.7241V13.8537Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 13.9412H11.8031V14.0286H15.7241V13.9412Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 14.0286H11.8031V14.116H15.7241V14.0286Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 14.116H11.8031V14.2035H15.7241V14.116Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 14.2035H11.8031V14.2909H15.7241V14.2035Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 14.2909H11.8031V14.3783H15.7241V14.2909Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 14.3784H11.8031V14.4658H15.7241V14.3784Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 14.4665H11.8031V14.5539H15.7241V14.4665Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 14.5539H11.8031V14.6414H15.7241V14.5539Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 14.6414H11.8031V14.7288H15.7241V14.6414Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 14.7288H11.8031V14.8162H15.7241V14.7288Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 14.8163H11.8031V14.9037H15.7241V14.8163Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 14.9037H11.8031V14.9911H15.7241V14.9037Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 14.9911H11.8031V15.0786H15.7241V14.9911Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 15.0793H11.8031V15.1667H15.7241V15.0793Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 15.1667H11.8031V15.2541H15.7241V15.1667Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 15.2541H11.8031V15.3416H15.7241V15.2541Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 15.3416H11.8031V15.429H15.7241V15.3416Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 15.429H11.8031V15.5165H15.7241V15.429Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 15.5165H11.8031V15.6039H15.7241V15.5165Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 15.6039H11.8031V15.6914H15.7241V15.6039Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 15.692H11.8031V15.7795H15.7241V15.692Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 15.7795H11.8031V15.8669H15.7241V15.7795Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 15.8669H11.8031V15.9544H15.7241V15.8669Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 15.9544H11.8031V16.0418H15.7241V15.9544Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 16.0418H11.8031V16.1293H15.7241V16.0418Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 16.1292H11.8031V16.2167H15.7241V16.1292Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 16.2167H11.8031V16.3041H15.7241V16.2167Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 16.3048H11.8031V16.3923H15.7241V16.3048Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 16.3923H11.8031V16.4797H15.7241V16.3923Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 16.4797H11.8031V16.5671H15.7241V16.4797Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 16.5671H11.8031V16.6546H15.7241V16.5671Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 16.6546H11.8031V16.742H15.7241V16.6546Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 16.742H11.8031V16.8294H15.7241V16.742Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 16.8302H11.8031V16.9176H15.7241V16.8302Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 16.9176H11.8031V17.005H15.7241V16.9176Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 17.005H11.8031V17.0925H15.7241V17.005Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 17.0925H11.8031V17.1799H15.7241V17.0925Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 17.1799H11.8031V17.2673H15.7241V17.1799Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 17.2673H11.8031V17.3548H15.7241V17.2673Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 17.3548H11.8031V17.4422H15.7241V17.3548Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 17.4429H11.8031V17.5304H15.7241V17.4429Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 17.5304H11.8031V17.6178H15.7241V17.5304Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 17.6178H11.8031V17.7053H15.7241V17.6178Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 17.7052H11.8031V17.7927H15.7241V17.7052Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 17.7927H11.8031V17.8801H15.7241V17.7927Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 17.8801H11.8031V17.9676H15.7241V17.8801Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 17.9676H11.8031V18.055H15.7241V17.9676Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 18.0557H11.8031V18.1431H15.7241V18.0557Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 18.1431H11.8031V18.2306H15.7241V18.1431Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 18.2306H11.8031V18.318H15.7241V18.2306Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 18.318H11.8031V18.4055H15.7241V18.318Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 18.4055H11.8031V18.4929H15.7241V18.4055Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 18.4929H11.8031V18.5803H15.7241V18.4929Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 18.5804H11.8031V18.6678H15.7241V18.5804Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 18.6685H11.8031V18.7559H15.7241V18.6685Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 18.7559H11.8031V18.8433H15.7241V18.7559Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 18.8434H11.8031V18.9308H15.7241V18.8434Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 18.9308H11.8031V19.0182H15.7241V18.9308Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.0182H11.8031V19.1057H15.7241V19.0182Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.1057H11.8031V19.1931H15.7241V19.1057Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.1931H11.8031V19.2806H15.7241V19.1931Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.2812H11.8031V19.3687H15.7241V19.2812Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.3687H11.8031V19.4561H15.7241V19.3687Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.4561H11.8031V19.5436H15.7241V19.4561Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.5436H11.8031V19.631H15.7241V19.5436Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.631H11.8031V19.7185H15.7241V19.631Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.7185H11.8031V19.8059H15.7241V19.7185Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.8059H11.8031V19.8933H15.7241V19.8059Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.894H11.8031V19.9815H15.7241V19.894Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 19.9815H11.8031V20.0689H15.7241V19.9815Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 20.0689H11.8031V20.1563H15.7241V20.0689Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 20.1563H11.8031V20.2438H15.7241V20.1563Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 20.2438H11.8031V20.3312H15.7241V20.2438Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 20.3312H11.8031V20.4187H15.7241V20.3312Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 20.4194H11.8031V20.5068H15.7241V20.4194Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 20.5068H11.8031V20.5942H15.7241V20.5068Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 20.5942H11.8031V20.6817H15.7241V20.5942Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 20.6817H11.8031V20.7691H15.7241V20.6817Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 20.7691H11.8031V20.8566H15.7241V20.7691Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 20.8566H11.8031V20.944H15.7241V20.8566Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 20.944H11.8031V21.0315H15.7241V20.944Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 21.0321H11.8031V21.1196H15.7241V21.0321Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 21.1196H11.8031V21.207H15.7241V21.1196Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 21.207H11.8031V21.2945H15.7241V21.207Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 21.2945H11.8031V21.3819H15.7241V21.2945Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 21.3819H11.8031V21.4693H15.7241V21.3819Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 21.4693H11.8031V21.5568H15.7241V21.4693Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 21.5568H11.8031V21.6442H15.7241V21.5568Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 21.6449H11.8031V21.7324H15.7241V21.6449Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 21.7324H11.8031V21.8198H15.7241V21.7324Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 21.8198H11.8031V21.9072H15.7241V21.8198Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 21.9072H11.8031V21.9947H15.7241V21.9072Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 21.9947H11.8031V22.0821H15.7241V21.9947Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 22.0821H11.8031V22.1695H15.7241V22.0821Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 22.1696H11.8031V22.257H15.7241V22.1696Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 22.2577H11.8031V22.3451H15.7241V22.2577Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 22.3451H11.8031V22.4326H15.7241V22.3451Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 22.4326H11.8031V22.52H15.7241V22.4326Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 22.52H11.8031V22.6074H15.7241V22.52Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 22.6075H11.8031V22.6949H15.7241V22.6075Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 22.6949H11.8031V22.7823H15.7241V22.6949Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 22.7823H11.8031V22.8698H15.7241V22.7823Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 22.8705H11.8031V22.9579H15.7241V22.8705Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 22.9579H11.8031V23.0453H15.7241V22.9579Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 23.0453H11.8031V23.1328H15.7241V23.0453Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 23.1328H11.8031V23.2202H15.7241V23.1328Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 23.2202H11.8031V23.3077H15.7241V23.2202Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 23.3077H11.8031V23.3951H15.7241V23.3077Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 23.3951H11.8031V23.4826H15.7241V23.3951Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 23.4832H11.8031V23.5707H15.7241V23.4832Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 23.5707H11.8031V23.6581H15.7241V23.5707Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 23.6581H11.8031V23.7456H15.7241V23.6581Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 23.7456H11.8031V23.833H15.7241V23.7456Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 23.833H11.8031V23.9205H15.7241V23.833Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 23.9204H11.8031V24.0079H15.7241V23.9204Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 24.0086H11.8031V24.096H15.7241V24.0086Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 24.096H11.8031V24.1835H15.7241V24.096Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 24.1835H11.8031V24.2709H15.7241V24.1835Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 24.2709H11.8031V24.3583H15.7241V24.2709Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 24.3583H11.8031V24.4458H15.7241V24.3583Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 24.4458H11.8031V24.5332H15.7241V24.4458Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 24.5332H11.8031V24.6207H15.7241V24.5332Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 24.6214H11.8031V24.7088H15.7241V24.6214Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 24.7088H11.8031V24.7962H15.7241V24.7088Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 24.7962H11.8031V24.8837H15.7241V24.7962Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 24.8837H11.8031V24.9711H15.7241V24.8837Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 24.9711H11.8031V25.0586H15.7241V24.9711Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 25.0586H11.8031V25.146H15.7241V25.0586Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 25.146H11.8031V25.2334H15.7241V25.146Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 25.2341H11.8031V25.3216H15.7241V25.2341Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 25.3216H11.8031V25.409H15.7241V25.3216Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 25.409H11.8031V25.4965H15.7241V25.409Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 25.4965H11.8031V25.5839H15.7241V25.4965Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 25.5839H11.8031V25.6713H15.7241V25.5839Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 25.6713H11.8031V25.7588H15.7241V25.6713Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 25.7588H11.8031V25.8462H15.7241V25.7588Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 25.8469H11.8031V25.9344H15.7241V25.8469Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 25.9344H11.8031V26.0218H15.7241V25.9344Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 26.0218H11.8031V26.1092H15.7241V26.0218Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 26.1092H11.8031V26.1967H15.7241V26.1092Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 26.1967H11.8031V26.2841H15.7241V26.1967Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 26.2841H11.8031V26.3716H15.7241V26.2841Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 26.3716H11.8031V26.459H15.7241V26.3716Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7241 26.4597H11.8031V26.5471H15.7241V26.4597Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_121_1869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 14,
    width: 5,
    height: 13
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1023 21.5878C36.1023 20.2355 36.1023 18.8826 36.1037 17.5304C36.1037 17.4712 36.092 17.4243 36.0494 17.3796C35.8599 17.1778 35.6738 16.9727 35.4863 16.7689C35.3071 16.574 35.1265 16.3806 34.9473 16.1864C34.6039 15.8125 34.2606 15.44 33.9186 15.0648C33.8753 15.0173 33.83 14.998 33.7655 14.9987C33.2745 15.0008 32.7828 15.0001 32.2918 15.0001C32.276 15.0001 32.2602 15.0015 32.2451 15.0001C32.2005 14.9966 32.182 15.0166 32.1854 15.06C32.1875 15.0786 32.1854 15.0972 32.1854 15.1164V26.3826C32.1854 26.417 32.1854 26.4507 32.1854 26.4852C32.1868 26.5602 32.1875 26.5602 32.2651 26.5616H33.7105C33.8355 26.5616 33.8266 26.574 33.8266 26.4466V23.4171C33.8266 23.3986 33.8266 23.38 33.8266 23.3607C33.8287 23.2898 33.8314 23.2856 33.9008 23.285C34.0443 23.2836 34.1871 23.285 34.3299 23.285C34.416 23.285 34.459 23.3272 34.459 23.4116V26.4225C34.459 26.4473 34.459 26.4721 34.459 26.4969C34.459 26.5272 34.4728 26.5444 34.503 26.5451C34.5284 26.5451 34.5531 26.5451 34.5778 26.5451H35.9766C36.1153 26.5451 36.1023 26.5575 36.1023 26.4197V21.5857V21.5878ZM34.459 21.5224C34.459 21.5382 34.459 21.554 34.459 21.5692C34.4563 21.638 34.4542 21.6415 34.3828 21.6422C34.2214 21.6435 34.0601 21.6435 33.898 21.6422C33.8321 21.6422 33.83 21.6373 33.8266 21.5733C33.8266 21.5609 33.8266 21.5485 33.8266 21.5361V16.8556C33.8266 16.8343 33.8211 16.8122 33.8362 16.7868C33.8781 16.7923 33.9001 16.8191 33.9234 16.8432C34.08 17.0119 34.2338 17.1827 34.3924 17.3493C34.4439 17.403 34.4611 17.4601 34.4604 17.5338C34.4583 18.8633 34.459 20.1922 34.459 21.5224Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_121_1869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 16.7861H33.8218V16.8219H34.4611V16.7861Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 16.8219H33.8218V16.8846H34.4611V16.8219Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 16.8846H33.8218V16.9472H34.4611V16.8846Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 16.9479H33.8218V17.0105H34.4611V16.9479Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.0105H33.8218V17.0732H34.4611V17.0105Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.0732H33.8218V17.1359H34.4611V17.0732Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.1359H33.8218V17.1985H34.4611V17.1359Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.1992H33.8218V17.2619H34.4611V17.1992Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.2619H33.8218V17.3245H34.4611V17.2619Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.3245H33.8218V17.3872H34.4611V17.3245Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.3878H33.8218V17.4505H34.4611V17.3878Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.4505H33.8218V17.5132H34.4611V17.4505Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.5132H33.8218V17.5758H34.4611V17.5132Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.5758H33.8218V17.6385H34.4611V17.5758Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.6392H33.8218V17.7018H34.4611V17.6392Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.7018H33.8218V17.7645H34.4611V17.7018Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.7645H33.8218V17.8271H34.4611V17.7645Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.8278H33.8218V17.8905H34.4611V17.8278Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.8905H33.8218V17.9531H34.4611V17.8905Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 17.9531H33.8218V18.0158H34.4611V17.9531Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.0158H33.8218V18.0784H34.4611V18.0158Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.0791H33.8218V18.1418H34.4611V18.0791Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.1418H33.8218V18.2044H34.4611V18.1418Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.2044H33.8218V18.2671H34.4611V18.2044Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.2671H33.8218V18.3297H34.4611V18.2671Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.3304H33.8218V18.3931H34.4611V18.3304Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.3931H33.8218V18.4557H34.4611V18.3931Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.4557H33.8218V18.5184H34.4611V18.4557Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.5191H33.8218V18.5817H34.4611V18.5191Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.5817H33.8218V18.6444H34.4611V18.5817Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.6444H33.8218V18.707H34.4611V18.6444Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.707H33.8218V18.7697H34.4611V18.707Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.7704H33.8218V18.833H34.4611V18.7704Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.833H33.8218V18.8957H34.4611V18.833Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.8957H33.8218V18.9583H34.4611V18.8957Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 18.959H33.8218V19.0217H34.4611V18.959Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.0217H33.8218V19.0843H34.4611V19.0217Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.0844H33.8218V19.147H34.4611V19.0844Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.147H33.8218V19.2097H34.4611V19.147Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.2103H33.8218V19.273H34.4611V19.2103Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.273H33.8218V19.3356H34.4611V19.273Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.3356H33.8218V19.3983H34.4611V19.3356Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.3983H33.8218V19.461H34.4611V19.3983Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.4617H33.8218V19.5243H34.4611V19.4617Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.5243H33.8218V19.587H34.4611V19.5243Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.587H33.8218V19.6496H34.4611V19.587Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.6503H33.8218V19.713H34.4611V19.6503Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.713H33.8218V19.7756H34.4611V19.713Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.7756H33.8218V19.8383H34.4611V19.7756Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.8383H33.8218V19.9009H34.4611V19.8383Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.9016H33.8218V19.9643H34.4611V19.9016Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 19.9643H33.8218V20.0269H34.4611V19.9643Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.0269H33.8218V20.0896H34.4611V20.0269Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.0903H33.8218V20.1529H34.4611V20.0903Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.1529H33.8218V20.2156H34.4611V20.1529Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.2156H33.8218V20.2782H34.4611V20.2156Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.2782H33.8218V20.3409H34.4611V20.2782Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.3416H33.8218V20.4042H34.4611V20.3416Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.4042H33.8218V20.4669H34.4611V20.4042Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.4669H33.8218V20.5295H34.4611V20.4669Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.5295H33.8218V20.5922H34.4611V20.5295Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.5929H33.8218V20.6555H34.4611V20.5929Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.6555H33.8218V20.7182H34.4611V20.6555Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.7182H33.8218V20.7808H34.4611V20.7182Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.7815H33.8218V20.8442H34.4611V20.7815Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.8442H33.8218V20.9068H34.4611V20.8442Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.9068H33.8218V20.9695H34.4611V20.9068Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 20.9695H33.8218V21.0322H34.4611V20.9695Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 21.0328H33.8218V21.0955H34.4611V21.0328Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 21.0955H33.8218V21.1581H34.4611V21.0955Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 21.1582H33.8218V21.2208H34.4611V21.1582Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 21.2215H33.8218V21.2842H34.4611V21.2215Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 21.2841H33.8218V21.3468H34.4611V21.2841Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 21.3468H33.8218V21.4095H34.4611V21.3468Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 21.4095H33.8218V21.4721H34.4611V21.4095Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 21.4728H33.8218V21.5354H34.4611V21.4728Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 21.5354H33.8218V21.5981H34.4611V21.5354Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4611 21.5981H33.8218V21.6435H34.4611V21.5981Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 14.9974H32.1813V14.9994H36.1154V14.9974Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 14.9994H32.1813V15.0621H36.1154V14.9994Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.0621H32.1813V15.1247H36.1154V15.0621Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.1254H32.1813V15.1881H36.1154V15.1254Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.188H32.1813V15.2507H36.1154V15.188Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.2507H32.1813V15.3134H36.1154V15.2507Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.3134H32.1813V15.376H36.1154V15.3134Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.3767H32.1813V15.4394H36.1154V15.3767Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.4394H32.1813V15.502H36.1154V15.4394Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.502H32.1813V15.5647H36.1154V15.502Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.5654H32.1813V15.628H36.1154V15.5654Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.628H32.1813V15.6907H36.1154V15.628Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.6907H32.1813V15.7533H36.1154V15.6907Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.7533H32.1813V15.816H36.1154V15.7533Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.8167H32.1813V15.8793H36.1154V15.8167Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.8793H32.1813V15.942H36.1154V15.8793Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 15.942H32.1813V16.0046H36.1154V15.942Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.0046H32.1813V16.0673H36.1154V16.0046Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.068H32.1813V16.1306H36.1154V16.068Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.1306H32.1813V16.1933H36.1154V16.1306Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.1933H32.1813V16.2559H36.1154V16.1933Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.2566H32.1813V16.3193H36.1154V16.2566Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.3193H32.1813V16.3819H36.1154V16.3193Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.3819H32.1813V16.4446H36.1154V16.3819Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.4446H32.1813V16.5072H36.1154V16.4446Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.5079H32.1813V16.5706H36.1154V16.5079Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.5706H32.1813V16.6332H36.1154V16.5706Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.6333H32.1813V16.6959H36.1154V16.6333Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.6966H32.1813V16.7592H36.1154V16.6966Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.7592H32.1813V16.8219H36.1154V16.7592Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.8219H32.1813V16.8846H36.1154V16.8219Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.8846H32.1813V16.9472H36.1154V16.8846Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 16.9479H32.1813V17.0105H36.1154V16.9479Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.0105H32.1813V17.0732H36.1154V17.0105Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.0732H32.1813V17.1359H36.1154V17.0732Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.1359H32.1813V17.1985H36.1154V17.1359Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.1992H32.1813V17.2619H36.1154V17.1992Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.2619H32.1813V17.3245H36.1154V17.2619Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.3245H32.1813V17.3872H36.1154V17.3245Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.3878H32.1813V17.4505H36.1154V17.3878Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.4505H32.1813V17.5132H36.1154V17.4505Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.5132H32.1813V17.5758H36.1154V17.5132Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.5758H32.1813V17.6385H36.1154V17.5758Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.6392H32.1813V17.7018H36.1154V17.6392Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.7018H32.1813V17.7645H36.1154V17.7018Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.7645H32.1813V17.8271H36.1154V17.7645Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.8278H32.1813V17.8905H36.1154V17.8278Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.8905H32.1813V17.9531H36.1154V17.8905Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 17.9531H32.1813V18.0158H36.1154V17.9531Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.0158H32.1813V18.0784H36.1154V18.0158Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.0791H32.1813V18.1418H36.1154V18.0791Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.1418H32.1813V18.2044H36.1154V18.1418Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.2044H32.1813V18.2671H36.1154V18.2044Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.2671H32.1813V18.3297H36.1154V18.2671Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.3304H32.1813V18.3931H36.1154V18.3304Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.3931H32.1813V18.4557H36.1154V18.3931Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.4557H32.1813V18.5184H36.1154V18.4557Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.5191H32.1813V18.5817H36.1154V18.5191Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.5817H32.1813V18.6444H36.1154V18.5817Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.6444H32.1813V18.707H36.1154V18.6444Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.707H32.1813V18.7697H36.1154V18.707Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.7704H32.1813V18.833H36.1154V18.7704Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.833H32.1813V18.8957H36.1154V18.833Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.8957H32.1813V18.9583H36.1154V18.8957Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 18.959H32.1813V19.0217H36.1154V18.959Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.0217H32.1813V19.0843H36.1154V19.0217Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.0844H32.1813V19.147H36.1154V19.0844Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.147H32.1813V19.2097H36.1154V19.147Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.2103H32.1813V19.273H36.1154V19.2103Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.273H32.1813V19.3356H36.1154V19.273Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.3356H32.1813V19.3983H36.1154V19.3356Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.3983H32.1813V19.461H36.1154V19.3983Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.4617H32.1813V19.5243H36.1154V19.4617Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.5243H32.1813V19.587H36.1154V19.5243Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.587H32.1813V19.6496H36.1154V19.587Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.6503H32.1813V19.713H36.1154V19.6503Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.713H32.1813V19.7756H36.1154V19.713Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.7756H32.1813V19.8383H36.1154V19.7756Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.8383H32.1813V19.9009H36.1154V19.8383Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.9016H32.1813V19.9643H36.1154V19.9016Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 19.9643H32.1813V20.0269H36.1154V19.9643Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.0269H32.1813V20.0896H36.1154V20.0269Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.0903H32.1813V20.1529H36.1154V20.0903Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.1529H32.1813V20.2156H36.1154V20.1529Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.2156H32.1813V20.2782H36.1154V20.2156Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.2782H32.1813V20.3409H36.1154V20.2782Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.3416H32.1813V20.4042H36.1154V20.3416Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.4042H32.1813V20.4669H36.1154V20.4042Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.4669H32.1813V20.5295H36.1154V20.4669Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.5295H32.1813V20.5922H36.1154V20.5295Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.5929H32.1813V20.6555H36.1154V20.5929Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.6555H32.1813V20.7182H36.1154V20.6555Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.7182H32.1813V20.7808H36.1154V20.7182Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.7815H32.1813V20.8442H36.1154V20.7815Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.8442H32.1813V20.9068H36.1154V20.8442Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.9068H32.1813V20.9695H36.1154V20.9068Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 20.9695H32.1813V21.0322H36.1154V20.9695Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.0328H32.1813V21.0955H36.1154V21.0328Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.0955H32.1813V21.1581H36.1154V21.0955Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.1582H32.1813V21.2208H36.1154V21.1582Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.2215H32.1813V21.2842H36.1154V21.2215Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.2841H32.1813V21.3468H36.1154V21.2841Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.3468H32.1813V21.4095H36.1154V21.3468Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.4095H32.1813V21.4721H36.1154V21.4095Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.4728H32.1813V21.5354H36.1154V21.4728Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.5354H32.1813V21.5981H36.1154V21.5354Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.5981H32.1813V21.6608H36.1154V21.5981Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.6608H32.1813V21.7234H36.1154V21.6608Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.7241H32.1813V21.7868H36.1154V21.7241Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.7868H32.1813V21.8494H36.1154V21.7868Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.8494H32.1813V21.9121H36.1154V21.8494Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.9128H32.1813V21.9754H36.1154V21.9128Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 21.9754H32.1813V22.0381H36.1154V21.9754Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.0381H32.1813V22.1007H36.1154V22.0381Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.1007H32.1813V22.1634H36.1154V22.1007Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.1641H32.1813V22.2267H36.1154V22.1641Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.2267H32.1813V22.2894H36.1154V22.2267Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.2894H32.1813V22.352H36.1154V22.2894Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.3527H32.1813V22.4154H36.1154V22.3527Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.4154H32.1813V22.478H36.1154V22.4154Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.478H32.1813V22.5407H36.1154V22.478Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.5407H32.1813V22.6033H36.1154V22.5407Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.604H32.1813V22.6667H36.1154V22.604Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.6667H32.1813V22.7293H36.1154V22.6667Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.7293H32.1813V22.792H36.1154V22.7293Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.792H32.1813V22.8546H36.1154V22.792Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.8553H32.1813V22.918H36.1154V22.8553Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.918H32.1813V22.9806H36.1154V22.918Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 22.9806H32.1813V23.0433H36.1154V22.9806Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.044H32.1813V23.1066H36.1154V23.044Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.1066H32.1813V23.1693H36.1154V23.1066Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.1693H32.1813V23.232H36.1154V23.1693Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.2319H32.1813V23.2946H36.1154V23.2319Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.2953H32.1813V23.3579H36.1154V23.2953Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.3579H32.1813V23.4206H36.1154V23.3579Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.4206H32.1813V23.4832H36.1154V23.4206Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.4839H32.1813V23.5466H36.1154V23.4839Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.5466H32.1813V23.6093H36.1154V23.5466Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.6093H32.1813V23.6719H36.1154V23.6093Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.6719H32.1813V23.7346H36.1154V23.6719Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.7352H32.1813V23.7979H36.1154V23.7352Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.7979H32.1813V23.8606H36.1154V23.7979Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.8606H32.1813V23.9232H36.1154V23.8606Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.9232H32.1813V23.9859H36.1154V23.9232Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 23.9866H32.1813V24.0492H36.1154V23.9866Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.0492H32.1813V24.1119H36.1154V24.0492Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.1119H32.1813V24.1745H36.1154V24.1119Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.1752H32.1813V24.2379H36.1154V24.1752Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.2379H32.1813V24.3005H36.1154V24.2379Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.3005H32.1813V24.3632H36.1154V24.3005Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.3632H32.1813V24.4258H36.1154V24.3632Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.4265H32.1813V24.4892H36.1154V24.4265Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.4892H32.1813V24.5518H36.1154V24.4892Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.5518H32.1813V24.6145H36.1154V24.5518Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.6152H32.1813V24.6778H36.1154V24.6152Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.6778H32.1813V24.7405H36.1154V24.6778Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.7405H32.1813V24.8031H36.1154V24.7405Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.8031H32.1813V24.8658H36.1154V24.8031Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.8665H32.1813V24.9291H36.1154V24.8665Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.9291H32.1813V24.9918H36.1154V24.9291Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 24.9918H32.1813V25.0544H36.1154V24.9918Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.0544H32.1813V25.1171H36.1154V25.0544Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.1178H32.1813V25.1804H36.1154V25.1178Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.1804H32.1813V25.2431H36.1154V25.1804Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.2431H32.1813V25.3057H36.1154V25.2431Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.3064H32.1813V25.3691H36.1154V25.3064Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.3691H32.1813V25.4317H36.1154V25.3691Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.4317H32.1813V25.4944H36.1154V25.4317Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.4944H32.1813V25.5571H36.1154V25.4944Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.5577H32.1813V25.6204H36.1154V25.5577Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.6204H32.1813V25.683H36.1154V25.6204Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.6831H32.1813V25.7457H36.1154V25.6831Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.7464H32.1813V25.8091H36.1154V25.7464Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.8091H32.1813V25.8717H36.1154V25.8091Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.8717H32.1813V25.9344H36.1154V25.8717Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.9344H32.1813V25.997H36.1154V25.9344Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 25.9977H32.1813V26.0604H36.1154V25.9977Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 26.0604H32.1813V26.123H36.1154V26.0604Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 26.123H32.1813V26.1857H36.1154V26.123Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 26.1857H32.1813V26.2483H36.1154V26.1857Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 26.249H32.1813V26.3117H36.1154V26.249Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 26.3117H32.1813V26.3743H36.1154V26.3117Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 26.3743H32.1813V26.437H36.1154V26.3743Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 26.4377H32.1813V26.5003H36.1154V26.4377Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1154 26.5003H32.1813V26.563H36.1154V26.5003Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_121_1869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 8,
    width: 2,
    height: 19
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.338 17.2763C16.338 14.2283 16.338 11.1809 16.338 8.13286C16.338 7.99446 16.3277 8.00755 16.463 8.00755C16.9293 8.00755 17.3955 8.00755 17.8618 8.00755C17.8803 8.00755 17.8989 8.00892 17.9174 8.00755C17.9682 8.00341 17.984 8.02889 17.9799 8.07502C17.9785 8.08741 17.9799 8.09981 17.9799 8.1122C17.9799 14.2138 17.9799 20.3161 17.9799 26.4177C17.9799 26.5035 17.9375 26.5464 17.8529 26.5464C17.3866 26.5464 16.9203 26.5464 16.4541 26.5464C16.4321 26.5464 16.4108 26.5464 16.3888 26.5464C16.3531 26.5471 16.3387 26.5278 16.3387 26.4941C16.3387 26.4659 16.3387 26.4383 16.3387 26.4101C16.3387 23.3655 16.338 20.3209 16.338 17.2763Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_121_1869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9846 7.99506H16.327V8.00745H17.9846V7.99506Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9846 8.00687H16.327V8.10739H17.9846V8.00687Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 8.10738H16.327V8.2079H17.9847V8.10738Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 8.2086H16.327V8.30912H17.9847V8.2086Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 8.3091H16.327V8.40964H17.9847V8.3091Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 8.41032H16.327V8.51085H17.9847V8.41032Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 8.51085H16.327V8.61137H17.9847V8.51085Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 8.61139H16.327V8.71191H17.9847V8.61139Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 8.71259H16.327V8.81311H17.9847V8.71259Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 8.81311H16.327V8.91363H17.9847V8.81311Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 8.91364H16.327V9.01416H17.9847V8.91364Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 9.01485H16.327V9.11537H17.9847V9.01485Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 9.11536H16.327V9.21588H17.9847V9.11536Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 9.21587H16.327V9.31639H17.9847V9.21587Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 9.31709H16.327V9.41761H17.9847V9.31709Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 9.41763H16.327V9.51816H17.9847V9.41763Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 9.51814H16.327V9.61867H17.9847V9.51814Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 9.61935H16.327V9.71988H17.9847V9.61935Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 9.71988H16.327V9.8204H17.9847V9.71988Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 9.8204H16.327V9.92093H17.9847V9.8204Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 9.92162H16.327V10.0221H17.9847V9.92162Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 10.0221H16.327V10.1227H17.9847V10.0221Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 10.1227H16.327V10.2232H17.9847V10.1227Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 10.2239H16.327V10.3244H17.9847V10.2239Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 10.3244H16.327V10.4249H17.9847V10.3244Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 10.4249H16.327V10.5254H17.9847V10.4249Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 10.5261H16.327V10.6266H17.9847V10.5261Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 10.6266H16.327V10.7272H17.9847V10.6266Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 10.7272H16.327V10.8277H17.9847V10.7272Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 10.8284H16.327V10.9289H17.9847V10.8284Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 10.9289H16.327V11.0294H17.9847V10.9289Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 11.0294H16.327V11.1299H17.9847V11.0294Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 11.1306H16.327V11.2312H17.9847V11.1306Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 11.2312H16.327V11.3317H17.9847V11.2312Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 11.3324H16.327V11.4329H17.9847V11.3324Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 11.4329H16.327V11.5334H17.9847V11.4329Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 11.5334H16.327V11.634H17.9847V11.5334Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 11.6346H16.327V11.7352H17.9847V11.6346Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 11.7352H16.327V11.8357H17.9847V11.7352Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 11.8357H16.327V11.9362H17.9847V11.8357Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 11.9369H16.327V12.0374H17.9847V11.9369Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 12.0374H16.327V12.1379H17.9847V12.0374Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 12.1379H16.327V12.2385H17.9847V12.1379Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 12.2392H16.327V12.3397H17.9847V12.2392Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 12.3397H16.327V12.4402H17.9847V12.3397Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 12.4402H16.327V12.5407H17.9847V12.4402Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 12.5414H16.327V12.6419H17.9847V12.5414Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 12.6419H16.327V12.7425H17.9847V12.6419Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 12.7425H16.327V12.843H17.9847V12.7425Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 12.8437H16.327V12.9442H17.9847V12.8437Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 12.9442H16.327V13.0447H17.9847V12.9442Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 13.0447H16.327V13.1452H17.9847V13.0447Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 13.1459H16.327V13.2464H17.9847V13.1459Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 13.2464H16.327V13.347H17.9847V13.2464Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 13.347H16.327V13.4475H17.9847V13.347Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 13.4482H16.327V13.5487H17.9847V13.4482Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 13.5487H16.327V13.6492H17.9847V13.5487Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 13.6492H16.327V13.7497H17.9847V13.6492Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 13.7504H16.327V13.851H17.9847V13.7504Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 13.851H16.327V13.9515H17.9847V13.851Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 13.9515H16.327V14.052H17.9847V13.9515Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 14.0527H16.327V14.1532H17.9847V14.0527Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 14.1532H16.327V14.2537H17.9847V14.1532Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 14.2544H16.327V14.3549H17.9847V14.2544Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 14.3549H16.327V14.4555H17.9847V14.3549Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 14.4555H16.327V14.556H17.9847V14.4555Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 14.5567H16.327V14.6572H17.9847V14.5567Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 14.6572H16.327V14.7577H17.9847V14.6572Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 14.7577H16.327V14.8582H17.9847V14.7577Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 14.8589H16.327V14.9595H17.9847V14.8589Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 14.9595H16.327V15.06H17.9847V14.9595Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 15.06H16.327V15.1605H17.9847V15.06Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 15.1612H16.327V15.2617H17.9847V15.1612Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 15.2617H16.327V15.3622H17.9847V15.2617Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 15.3622H16.327V15.4628H17.9847V15.3622Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 15.4635H16.327V15.564H17.9847V15.4635Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 15.564H16.327V15.6645H17.9847V15.564Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 15.6645H16.327V15.765H17.9847V15.6645Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 15.7657H16.327V15.8662H17.9847V15.7657Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 15.8662H16.327V15.9667H17.9847V15.8662Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 15.9668H16.327V16.0673H17.9847V15.9668Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 16.068H16.327V16.1685H17.9847V16.068Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 16.1685H16.327V16.269H17.9847V16.1685Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 16.269H16.327V16.3695H17.9847V16.269Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 16.3702H16.327V16.4707H17.9847V16.3702Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 16.4707H16.327V16.5713H17.9847V16.4707Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 16.5713H16.327V16.6718H17.9847V16.5713Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 16.6725H16.327V16.773H17.9847V16.6725Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 16.773H16.327V16.8735H17.9847V16.773Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 16.8735H16.327V16.9741H17.9847V16.8735Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 16.9747H16.327V17.0753H17.9847V16.9747Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 17.0753H16.327V17.1758H17.9847V17.0753Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 17.1765H16.327V17.277H17.9847V17.1765Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 17.277H16.327V17.3775H17.9847V17.277Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 17.3775H16.327V17.478H17.9847V17.3775Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 17.4787H16.327V17.5793H17.9847V17.4787Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 17.5793H16.327V17.6798H17.9847V17.5793Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 17.6798H16.327V17.7803H17.9847V17.6798Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 17.781H16.327V17.8815H17.9847V17.781Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 17.8815H16.327V17.982H17.9847V17.8815Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 17.982H16.327V18.0826H17.9847V17.982Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 18.0832H16.327V18.1838H17.9847V18.0832Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 18.1838H16.327V18.2843H17.9847V18.1838Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 18.2843H16.327V18.3848H17.9847V18.2843Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 18.3855H16.327V18.486H17.9847V18.3855Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 18.486H16.327V18.5865H17.9847V18.486Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 18.5865H16.327V18.6871H17.9847V18.5865Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 18.6878H16.327V18.7883H17.9847V18.6878Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 18.7883H16.327V18.8888H17.9847V18.7883Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 18.8888H16.327V18.9893H17.9847V18.8888Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 18.99H16.327V19.0905H17.9847V18.99Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 19.0905H16.327V19.1911H17.9847V19.0905Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 19.1911H16.327V19.2916H17.9847V19.1911Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 19.2923H16.327V19.3928H17.9847V19.2923Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 19.3928H16.327V19.4933H17.9847V19.3928Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 19.4933H16.327V19.5938H17.9847V19.4933Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 19.5945H16.327V19.6951H17.9847V19.5945Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 19.6951H16.327V19.7956H17.9847V19.6951Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 19.7956H16.327V19.8961H17.9847V19.7956Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 19.8968H16.327V19.9973H17.9847V19.8968Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 19.9973H16.327V20.0978H17.9847V19.9973Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 20.0978H16.327V20.1983H17.9847V20.0978Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 20.199H16.327V20.2996H17.9847V20.199Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 20.2996H16.327V20.4001H17.9847V20.2996Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 20.4008H16.327V20.5013H17.9847V20.4008Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 20.5013H16.327V20.6018H17.9847V20.5013Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 20.6018H16.327V20.7023H17.9847V20.6018Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 20.703H16.327V20.8036H17.9847V20.703Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 20.8036H16.327V20.9041H17.9847V20.8036Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 20.9041H16.327V21.0046H17.9847V20.9041Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 21.0053H16.327V21.1058H17.9847V21.0053Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 21.1058H16.327V21.2063H17.9847V21.1058Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 21.2063H16.327V21.3069H17.9847V21.2063Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 21.3076H16.327V21.4081H17.9847V21.3076Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 21.4081H16.327V21.5086H17.9847V21.4081Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 21.5086H16.327V21.6091H17.9847V21.5086Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 21.6098H16.327V21.7103H17.9847V21.6098Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 21.7103H16.327V21.8108H17.9847V21.7103Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 21.8109H16.327V21.9114H17.9847V21.8109Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 21.9121H16.327V22.0126H17.9847V21.9121Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 22.0126H16.327V22.1131H17.9847V22.0126Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 22.1131H16.327V22.2136H17.9847V22.1131Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 22.2143H16.327V22.3148H17.9847V22.2143Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 22.3148H16.327V22.4154H17.9847V22.3148Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 22.4154H16.327V22.5159H17.9847V22.4154Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 22.5166H16.327V22.6171H17.9847V22.5166Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 22.6171H16.327V22.7176H17.9847V22.6171Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 22.7176H16.327V22.8181H17.9847V22.7176Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 22.8188H16.327V22.9194H17.9847V22.8188Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 22.9194H16.327V23.0199H17.9847V22.9194Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 23.0199H16.327V23.1204H17.9847V23.0199Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 23.1211H16.327V23.2216H17.9847V23.1211Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 23.2216H16.327V23.3221H17.9847V23.2216Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 23.3228H16.327V23.4234H17.9847V23.3228Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 23.4233H16.327V23.5239H17.9847V23.4233Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 23.5239H16.327V23.6244H17.9847V23.5239Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 23.6251H16.327V23.7256H17.9847V23.6251Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 23.7256H16.327V23.8261H17.9847V23.7256Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 23.8261H16.327V23.9266H17.9847V23.8261Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 23.9273H16.327V24.0279H17.9847V23.9273Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 24.0279H16.327V24.1284H17.9847V24.0279Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 24.1284H16.327V24.2289H17.9847V24.1284Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 24.2296H16.327V24.3301H17.9847V24.2296Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 24.3301H16.327V24.4306H17.9847V24.3301Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 24.4306H16.327V24.5312H17.9847V24.4306Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 24.5318H16.327V24.6324H17.9847V24.5318Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 24.6324H16.327V24.7329H17.9847V24.6324Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 24.7329H16.327V24.8334H17.9847V24.7329Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 24.8341H16.327V24.9346H17.9847V24.8341Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 24.9346H16.327V25.0352H17.9847V24.9346Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 25.0352H16.327V25.1357H17.9847V25.0352Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 25.1364H16.327V25.2369H17.9847V25.1364Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 25.2369H16.327V25.3374H17.9847V25.2369Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 25.3374H16.327V25.4379H17.9847V25.3374Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 25.4386H16.327V25.5391H17.9847V25.4386Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 25.5391H16.327V25.6397H17.9847V25.5391Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 25.6397H16.327V25.7402H17.9847V25.6397Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 25.7409H16.327V25.8414H17.9847V25.7409Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 25.8414H16.327V25.9419H17.9847V25.8414Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 25.9419H16.327V26.0424H17.9847V25.9419Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 26.0431H16.327V26.1436H17.9847V26.0431Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 26.1436H16.327V26.2442H17.9847V26.1436Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 26.2449H16.327V26.3454H17.9847V26.2449Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 26.3454H16.327V26.4459H17.9847V26.3454Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9847 26.4459H16.327V26.5464H17.9847V26.4459Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_121_1869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 17,
    width: 4,
    height: 10
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90178 26.4239V17.551C8.90178 17.5297 8.90178 17.5076 8.90178 17.4856C8.90384 17.4519 8.88942 17.4333 8.85371 17.434C8.83792 17.434 8.82213 17.434 8.80702 17.434C8.31878 17.434 7.83054 17.4353 7.34299 17.4326C7.28531 17.4326 7.24411 17.4498 7.20291 17.489C6.91038 17.7686 6.6151 18.0447 6.32119 18.3235C5.90163 18.7215 5.48343 19.1215 5.06249 19.5195C5.01785 19.5615 5 19.6028 5 19.6647C5.00206 21.921 5.00137 24.1773 5.00137 26.4342C5.00137 26.4555 5.00137 26.4783 5.00137 26.4996C5.00137 26.5292 5.01442 26.5464 5.04532 26.5471C5.06661 26.5471 5.08927 26.5471 5.11056 26.5471C5.583 26.5471 6.05613 26.5471 6.52858 26.5471C6.65699 26.5471 6.64394 26.5492 6.64394 26.4294V23.4192C6.64394 23.4006 6.64394 23.382 6.64394 23.3627C6.646 23.2911 6.64806 23.287 6.71742 23.287C6.87604 23.2849 7.03467 23.2849 7.19329 23.287C7.26334 23.287 7.26746 23.2932 7.2702 23.3607C7.2702 23.3793 7.2702 23.3979 7.2702 23.4171V26.428C7.2702 26.4493 7.2702 26.4714 7.2702 26.4934C7.26814 26.534 7.29012 26.5485 7.3272 26.5478C7.34574 26.5478 7.36428 26.5478 7.38351 26.5478H8.7823C8.91208 26.5478 8.90178 26.5568 8.90178 26.4252V26.4239ZM7.2702 19.0988V21.521C7.2702 21.5423 7.2702 21.5643 7.2702 21.5857C7.27158 21.6256 7.25235 21.6428 7.21389 21.6422H7.02711C6.92136 21.6422 6.8163 21.6408 6.71055 21.6422C6.66317 21.6435 6.63913 21.6263 6.64325 21.5774C6.64463 21.565 6.64325 21.552 6.64325 21.5403C6.64325 20.9103 6.64325 20.281 6.64119 19.6517C6.64119 19.5863 6.65973 19.5394 6.70918 19.4981C6.87329 19.359 7.02437 19.2076 7.17887 19.0582C7.19398 19.043 7.20909 19.0258 7.22694 19.0148C7.24548 19.0031 7.26402 19.0093 7.26746 19.0334C7.2702 19.0547 7.26883 19.0774 7.26883 19.0988H7.2702Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_121_1869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.0031H6.6391V19.0175H7.27154V19.0031Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.0175H6.6391V19.0671H7.27154V19.0175Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.0671H6.6391V19.1167H7.27154V19.0671Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.1167H6.6391V19.1663H7.27154V19.1167Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.1663H6.6391V19.2158H7.27154V19.1663Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.2158H6.6391V19.2654H7.27154V19.2158Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.2654H6.6391V19.315H7.27154V19.2654Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.315H6.6391V19.3646H7.27154V19.315Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.3645H6.6391V19.4141H7.27154V19.3645Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.4141H6.6391V19.4637H7.27154V19.4141Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.4637H6.6391V19.5133H7.27154V19.4637Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.5133H6.6391V19.5628H7.27154V19.5133Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.5622H6.6391V19.6117H7.27154V19.5622Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.6117H6.6391V19.6613H7.27154V19.6117Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.6613H6.6391V19.7109H7.27154V19.6613Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.7109H6.6391V19.7604H7.27154V19.7109Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.7605H6.6391V19.81H7.27154V19.7605Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.81H6.6391V19.8596H7.27154V19.81Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.8596H6.6391V19.9092H7.27154V19.8596Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.9092H6.6391V19.9587H7.27154V19.9092Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 19.9587H6.6391V20.0083H7.27154V19.9587Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.0083H6.6391V20.0579H7.27154V20.0083Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.0579H6.6391V20.1075H7.27154V20.0579Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.1075H6.6391V20.157H7.27154V20.1075Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.157H6.6391V20.2066H7.27154V20.157Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.2066H6.6391V20.2562H7.27154V20.2066Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.2562H6.6391V20.3058H7.27154V20.2562Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.3058H6.6391V20.3553H7.27154V20.3058Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.3553H6.6391V20.4049H7.27154V20.3553Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.4049H6.6391V20.4545H7.27154V20.4049Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.4545H6.6391V20.5041H7.27154V20.4545Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.5034H6.6391V20.5529H7.27154V20.5034Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.5529H6.6391V20.6025H7.27154V20.5529Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.6025H6.6391V20.6521H7.27154V20.6025Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.6521H6.6391V20.7016H7.27154V20.6521Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.7016H6.6391V20.7512H7.27154V20.7016Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.7512H6.6391V20.8008H7.27154V20.7512Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.8008H6.6391V20.8504H7.27154V20.8008Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.8504H6.6391V20.8999H7.27154V20.8504Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.8999H6.6391V20.9495H7.27154V20.8999Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.9495H6.6391V20.9991H7.27154V20.9495Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 20.9991H6.6391V21.0487H7.27154V20.9991Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 21.0487H6.6391V21.0982H7.27154V21.0487Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 21.0982H6.6391V21.1478H7.27154V21.0982Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 21.1478H6.6391V21.1974H7.27154V21.1478Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 21.1974H6.6391V21.2469H7.27154V21.1974Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 21.2469H6.6391V21.2965H7.27154V21.2469Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 21.2965H6.6391V21.3461H7.27154V21.2965Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 21.3461H6.6391V21.3957H7.27154V21.3461Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 21.395H6.6391V21.4446H7.27154V21.395Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 21.4445H6.6391V21.4941H7.27154V21.4445Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 21.4941H6.6391V21.5437H7.27154V21.4941Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 21.5437H6.6391V21.5933H7.27154V21.5437Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 21.5933H6.6391V21.6428H7.27154V21.5933Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27154 21.6428H6.6391V21.6442H7.27154V21.6428Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 17.4326H5V17.4822H8.91208V17.4326Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 17.4822H5V17.5317H8.91208V17.4822Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 17.5317H5V17.5813H8.91208V17.5317Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 17.5813H5V17.6309H8.91208V17.5813Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 17.6309H5V17.6804H8.91208V17.6309Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 17.6798H5V17.7293H8.91208V17.6798Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 17.7293H5V17.7789H8.91208V17.7293Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 17.7789H5V17.8285H8.91208V17.7789Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 17.8285H5V17.8781H8.91208V17.8285Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 17.8781H5V17.9276H8.91208V17.8781Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 17.9276H5V17.9772H8.91208V17.9276Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 17.9772H5V18.0268H8.91208V17.9772Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.0268H5V18.0764H8.91208V18.0268Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.0764H5V18.1259H8.91208V18.0764Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.1259H5V18.1755H8.91208V18.1259Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.1755H5V18.2251H8.91208V18.1755Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.2251H5V18.2746H8.91208V18.2251Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.2746H5V18.3242H8.91208V18.2746Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.3242H5V18.3738H8.91208V18.3242Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.3738H5V18.4234H8.91208V18.3738Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.4234H5V18.4729H8.91208V18.4234Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.4729H5V18.5225H8.91208V18.4729Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.5225H5V18.5721H8.91208V18.5225Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.5721H5V18.6217H8.91208V18.5721Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.621H5V18.6705H8.91208V18.621Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.6705H5V18.7201H8.91208V18.6705Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.7201H5V18.7697H8.91208V18.7201Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.7697H5V18.8193H8.91208V18.7697Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.8193H5V18.8688H8.91208V18.8193Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.8688H5V18.9184H8.91208V18.8688Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.9184H5V18.968H8.91208V18.9184Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 18.968H5V19.0175H8.91208V18.968Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.0175H5V19.0671H8.91208V19.0175Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.0671H5V19.1167H8.91208V19.0671Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.1167H5V19.1663H8.91208V19.1167Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.1663H5V19.2158H8.91208V19.1663Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.2158H5V19.2654H8.91208V19.2158Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.2654H5V19.315H8.91208V19.2654Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.315H5V19.3646H8.91208V19.315Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.3645H5V19.4141H8.91208V19.3645Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.4141H5V19.4637H8.91208V19.4141Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.4637H5V19.5133H8.91208V19.4637Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.5133H5V19.5628H8.91208V19.5133Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.5622H5V19.6117H8.91208V19.5622Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.6117H5V19.6613H8.91208V19.6117Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.6613H5V19.7109H8.91208V19.6613Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.7109H5V19.7604H8.91208V19.7109Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.7605H5V19.81H8.91208V19.7605Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.81H5V19.8596H8.91208V19.81Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.8596H5V19.9092H8.91208V19.8596Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.9092H5V19.9587H8.91208V19.9092Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 19.9587H5V20.0083H8.91208V19.9587Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.0083H5V20.0579H8.91208V20.0083Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.0579H5V20.1075H8.91208V20.0579Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.1075H5V20.157H8.91208V20.1075Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.157H5V20.2066H8.91208V20.157Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.2066H5V20.2562H8.91208V20.2066Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.2562H5V20.3058H8.91208V20.2562Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.3058H5V20.3553H8.91208V20.3058Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.3553H5V20.4049H8.91208V20.3553Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.4049H5V20.4545H8.91208V20.4049Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.4545H5V20.5041H8.91208V20.4545Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.5034H5V20.5529H8.91208V20.5034Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.5529H5V20.6025H8.91208V20.5529Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.6025H5V20.6521H8.91208V20.6025Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.6521H5V20.7016H8.91208V20.6521Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.7016H5V20.7512H8.91208V20.7016Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.7512H5V20.8008H8.91208V20.7512Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.8008H5V20.8504H8.91208V20.8008Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.8504H5V20.8999H8.91208V20.8504Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.8999H5V20.9495H8.91208V20.8999Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.9495H5V20.9991H8.91208V20.9495Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 20.9991H5V21.0487H8.91208V20.9991Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.0487H5V21.0982H8.91208V21.0487Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.0982H5V21.1478H8.91208V21.0982Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.1478H5V21.1974H8.91208V21.1478Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.1974H5V21.2469H8.91208V21.1974Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.2469H5V21.2965H8.91208V21.2469Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.2965H5V21.3461H8.91208V21.2965Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.3461H5V21.3957H8.91208V21.3461Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.395H5V21.4446H8.91208V21.395Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.4445H5V21.4941H8.91208V21.4445Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.4941H5V21.5437H8.91208V21.4941Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.5437H5V21.5933H8.91208V21.5437Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.5933H5V21.6428H8.91208V21.5933Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.6428H5V21.6924H8.91208V21.6428Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.6924H5V21.742H8.91208V21.6924Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.742H5V21.7916H8.91208V21.742Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.7916H5V21.8411H8.91208V21.7916Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.8411H5V21.8907H8.91208V21.8411Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.8907H5V21.9403H8.91208V21.8907Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.9403H5V21.9899H8.91208V21.9403Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 21.9899H5V22.0394H8.91208V21.9899Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.0394H5V22.089H8.91208V22.0394Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.089H5V22.1386H8.91208V22.089Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.1386H5V22.1882H8.91208V22.1386Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.1881H5V22.2377H8.91208V22.1881Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.2377H5V22.2873H8.91208V22.2377Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.2873H5V22.3369H8.91208V22.2873Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.3362H5V22.3857H8.91208V22.3362Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.3858H5V22.4353H8.91208V22.3858Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.4353H5V22.4849H8.91208V22.4353Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.4849H5V22.5345H8.91208V22.4849Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.5345H5V22.584H8.91208V22.5345Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.584H5V22.6336H8.91208V22.584Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.6336H5V22.6832H8.91208V22.6336Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.6832H5V22.7328H8.91208V22.6832Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.7328H5V22.7823H8.91208V22.7328Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.7823H5V22.8319H8.91208V22.7823Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.8319H5V22.8815H8.91208V22.8319Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.8815H5V22.9311H8.91208V22.8815Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.931H5V22.9806H8.91208V22.931Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 22.9806H5V23.0302H8.91208V22.9806Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.0302H5V23.0798H8.91208V23.0302Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.0798H5V23.1293H8.91208V23.0798Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.1293H5V23.1789H8.91208V23.1293Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.1789H5V23.2285H8.91208V23.1789Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.2285H5V23.2781H8.91208V23.2285Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.2774H5V23.3269H8.91208V23.2774Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.327H5V23.3765H8.91208V23.327Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.3765H5V23.4261H8.91208V23.3765Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.4261H5V23.4757H8.91208V23.4261Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.4757H5V23.5252H8.91208V23.4757Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.5252H5V23.5748H8.91208V23.5252Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.5748H5V23.6244H8.91208V23.5748Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.6244H5V23.674H8.91208V23.6244Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.674H5V23.7235H8.91208V23.674Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.7235H5V23.7731H8.91208V23.7235Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.7731H5V23.8227H8.91208V23.7731Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.8227H5V23.8722H8.91208V23.8227Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.8722H5V23.9218H8.91208V23.8722Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.9218H5V23.9714H8.91208V23.9218Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 23.9714H5V24.021H8.91208V23.9714Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.021H5V24.0705H8.91208V24.021Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.0705H5V24.1201H8.91208V24.0705Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.1201H5V24.1697H8.91208V24.1201Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.169H5V24.2186H8.91208V24.169Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.2186H5V24.2681H8.91208V24.2186Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.2681H5V24.3177H8.91208V24.2681Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.3177H5V24.3673H8.91208V24.3177Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.3673H5V24.4169H8.91208V24.3673Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.4169H5V24.4664H8.91208V24.4169Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.4664H5V24.516H8.91208V24.4664Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.516H5V24.5656H8.91208V24.516Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.5656H5V24.6152H8.91208V24.5656Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.6152H5V24.6647H8.91208V24.6152Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.6647H5V24.7143H8.91208V24.6647Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.7143H5V24.7639H8.91208V24.7143Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.7639H5V24.8134H8.91208V24.7639Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.8134H5V24.863H8.91208V24.8134Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.863H5V24.9126H8.91208V24.863Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.9126H5V24.9622H8.91208V24.9126Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 24.9622H5V25.0117H8.91208V24.9622Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.0117H5V25.0613H8.91208V25.0117Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.0613H5V25.1109H8.91208V25.0613Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.1102H5V25.1598H8.91208V25.1102Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.1598H5V25.2093H8.91208V25.1598Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.2093H5V25.2589H8.91208V25.2093Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.2589H5V25.3085H8.91208V25.2589Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.3085H5V25.3581H8.91208V25.3085Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.3581H5V25.4076H8.91208V25.3581Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.4076H5V25.4572H8.91208V25.4076Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.4572H5V25.5068H8.91208V25.4572Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.5068H5V25.5563H8.91208V25.5068Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.5564H5V25.6059H8.91208V25.5564Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.6059H5V25.6555H8.91208V25.6059Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.6555H5V25.7051H8.91208V25.6555Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.7051H5V25.7547H8.91208V25.7051Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.7546H5V25.8042H8.91208V25.7546Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.8042H5V25.8538H8.91208V25.8042Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.8538H5V25.9033H8.91208V25.8538Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.9034H5V25.9529H8.91208V25.9034Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 25.9529H5V26.0025H8.91208V25.9529Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 26.0025H5V26.0521H8.91208V26.0025Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 26.0514H5V26.101H8.91208V26.0514Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 26.101H5V26.1505H8.91208V26.101Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 26.1505H5V26.2001H8.91208V26.1505Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 26.2001H5V26.2497H8.91208V26.2001Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 26.2497H5V26.2993H8.91208V26.2497Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 26.2993H5V26.3488H8.91208V26.2993Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 26.3488H5V26.3984H8.91208V26.3488Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 26.3984H5V26.448H8.91208V26.3984Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 26.448H5V26.4975H8.91208V26.448Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 26.4975H5V26.5471H8.91208V26.4975Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91208 26.5471H5V26.5561H8.91208V26.5471Z",
    fill: "#C8AD49"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_121_1869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 15,
    width: 5,
    height: 12
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53493 21.0707C9.53493 18.8957 9.53493 17.0078 9.53493 15.1199C9.53493 14.9925 9.52051 15.0008 9.65647 15.0008C10.1227 15.0008 10.589 15.0008 11.0553 15.0008C11.0772 15.0008 11.0985 15.0015 11.1205 15.0008C11.1583 14.9987 11.1796 15.0132 11.1775 15.0545C11.1761 15.0765 11.1775 15.0979 11.1775 15.1199C11.1775 18.3414 11.1775 21.5637 11.1775 24.7852C11.1775 24.8692 11.2203 24.9112 11.3059 24.9112C11.9775 24.9112 12.6491 24.9112 13.32 24.9112C13.4511 24.9112 13.4346 24.9098 13.4353 25.0283C13.4353 25.4958 13.4353 25.9633 13.4353 26.4301C13.4353 26.4487 13.434 26.4673 13.4353 26.4858C13.4381 26.5299 13.4182 26.5492 13.3749 26.5464C13.3529 26.5451 13.3316 26.5464 13.3097 26.5464C12.6415 26.5464 11.9727 26.5334 11.3045 26.5506C10.7545 26.565 10.2051 26.554 9.65579 26.5623C9.63381 26.5623 9.61252 26.5609 9.59055 26.5623C9.54798 26.565 9.52531 26.5492 9.52875 26.5037C9.53012 26.4879 9.52875 26.4728 9.52875 26.4569C9.52875 25.9646 9.52531 25.4724 9.52875 24.9801C9.54111 23.581 9.52875 22.182 9.53355 21.07L9.53493 21.0707Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_121_1869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 14.9925H9.52051V15.0008H13.4511V14.9925Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.0001H9.52051V15.0627H13.4511V15.0001Z",
    fill: "#EAE0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.0634H9.52051V15.1261H13.4511V15.0634Z",
    fill: "#E9DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.1261H9.52051V15.1887H13.4511V15.1261Z",
    fill: "#E9DED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.1887H9.52051V15.2514H13.4511V15.1887Z",
    fill: "#E8DDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.2514H9.52051V15.314H13.4511V15.2514Z",
    fill: "#E8DDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.3147H9.52051V15.3774H13.4511V15.3147Z",
    fill: "#E8DCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.3774H9.52051V15.44H13.4511V15.3774Z",
    fill: "#E7DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.44H9.52051V15.5027H13.4511V15.44Z",
    fill: "#E7DAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.5027H9.52051V15.5653H13.4511V15.5027Z",
    fill: "#E6DAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.566H9.52051V15.6287H13.4511V15.566Z",
    fill: "#E6D9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.6287H9.52051V15.6914H13.4511V15.6287Z",
    fill: "#E5D8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.6913H9.52051V15.754H13.4511V15.6913Z",
    fill: "#E5D8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.7547H9.52051V15.8174H13.4511V15.7547Z",
    fill: "#E4D7BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.8174H9.52051V15.88H13.4511V15.8174Z",
    fill: "#E4D6BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.88H9.52051V15.9427H13.4511V15.88Z",
    fill: "#E3D5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 15.9427H9.52051V16.0053H13.4511V15.9427Z",
    fill: "#E3D5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.006H9.52051V16.0687H13.4511V16.006Z",
    fill: "#E3D4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.0687H9.52051V16.1313H13.4511V16.0687Z",
    fill: "#E2D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.1313H9.52051V16.194H13.4511V16.1313Z",
    fill: "#E2D3B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.194H9.52051V16.2566H13.4511V16.194Z",
    fill: "#E1D2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.2573H9.52051V16.32H13.4511V16.2573Z",
    fill: "#E1D2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.32H9.52051V16.3826H13.4511V16.32Z",
    fill: "#E1D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.3826H9.52051V16.4453H13.4511V16.3826Z",
    fill: "#E0D0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.446H9.52051V16.5086H13.4511V16.446Z",
    fill: "#E0D0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.5086H9.52051V16.5713H13.4511V16.5086Z",
    fill: "#DFCFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.5713H9.52051V16.6339H13.4511V16.5713Z",
    fill: "#DFCFA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.6339H9.52051V16.6966H13.4511V16.6339Z",
    fill: "#DFCEA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.6973H9.52051V16.7599H13.4511V16.6973Z",
    fill: "#DECDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.7599H9.52051V16.8226H13.4511V16.7599Z",
    fill: "#DECDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.8226H9.52051V16.8852H13.4511V16.8226Z",
    fill: "#DECCA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.8852H9.52051V16.9479H13.4511V16.8852Z",
    fill: "#DDCCA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 16.9486H9.52051V17.0112H13.4511V16.9486Z",
    fill: "#DDCB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.0112H9.52051V17.0739H13.4511V17.0112Z",
    fill: "#DCCB9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.0739H9.52051V17.1365H13.4511V17.0739Z",
    fill: "#DCCA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.1372H9.52051V17.1999H13.4511V17.1372Z",
    fill: "#DCCA9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.1999H9.52051V17.2625H13.4511V17.1999Z",
    fill: "#DBC99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.2625H9.52051V17.3252H13.4511V17.2625Z",
    fill: "#DBC898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.3252H9.52051V17.3879H13.4511V17.3252Z",
    fill: "#DBC897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.3885H9.52051V17.4512H13.4511V17.3885Z",
    fill: "#DAC796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.4512H9.52051V17.5138H13.4511V17.4512Z",
    fill: "#DAC794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.5138H9.52051V17.5765H13.4511V17.5138Z",
    fill: "#DAC693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.5765H9.52051V17.6391H13.4511V17.5765Z",
    fill: "#D9C692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.6398H9.52051V17.7025H13.4511V17.6398Z",
    fill: "#D9C691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.7025H9.52051V17.7651H13.4511V17.7025Z",
    fill: "#D9C58F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.7652H9.52051V17.8278H13.4511V17.7652Z",
    fill: "#D8C58E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.8285H9.52051V17.8911H13.4511V17.8285Z",
    fill: "#D8C48D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.8911H9.52051V17.9538H13.4511V17.8911Z",
    fill: "#D8C48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 17.9538H9.52051V18.0165H13.4511V17.9538Z",
    fill: "#D7C38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.0164H9.52051V18.0791H13.4511V18.0164Z",
    fill: "#D7C38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.0798H9.52051V18.1425H13.4511V18.0798Z",
    fill: "#D7C288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.1425H9.52051V18.2051H13.4511V18.1425Z",
    fill: "#D7C287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.2051H9.52051V18.2678H13.4511V18.2051Z",
    fill: "#D6C286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.2678H9.52051V18.3304H13.4511V18.2678Z",
    fill: "#D6C185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.3311H9.52051V18.3938H13.4511V18.3311Z",
    fill: "#D6C184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.3938H9.52051V18.4564H13.4511V18.3938Z",
    fill: "#D5C083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.4564H9.52051V18.5191H13.4511V18.4564Z",
    fill: "#D5C082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.5198H9.52051V18.5824H13.4511V18.5198Z",
    fill: "#D5BF81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.5824H9.52051V18.6451H13.4511V18.5824Z",
    fill: "#D5BF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.6451H9.52051V18.7077H13.4511V18.6451Z",
    fill: "#D4BF7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.7077H9.52051V18.7704H13.4511V18.7077Z",
    fill: "#D4BE7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.7711H9.52051V18.8337H13.4511V18.7711Z",
    fill: "#D4BE7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.8337H9.52051V18.8964H13.4511V18.8337Z",
    fill: "#D3BE7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.8964H9.52051V18.959H13.4511V18.8964Z",
    fill: "#D3BD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 18.959H9.52051V19.0217H13.4511V18.959Z",
    fill: "#D3BD7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.0224H9.52051V19.085H13.4511V19.0224Z",
    fill: "#D3BC79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.085H9.52051V19.1477H13.4511V19.085Z",
    fill: "#D2BC78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.1477H9.52051V19.2103H13.4511V19.1477Z",
    fill: "#D2BC77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.211H9.52051V19.2737H13.4511V19.211Z",
    fill: "#D2BB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.2737H9.52051V19.3363H13.4511V19.2737Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.3363H9.52051V19.399H13.4511V19.3363Z",
    fill: "#D2BB75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.399H9.52051V19.4616H13.4511V19.399Z",
    fill: "#D1BA74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.4623H9.52051V19.525H13.4511V19.4623Z",
    fill: "#D1BA73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.525H9.52051V19.5876H13.4511V19.525Z",
    fill: "#D1BA72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.5876H9.52051V19.6503H13.4511V19.5876Z",
    fill: "#D1BA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.6503H9.52051V19.713H13.4511V19.6503Z",
    fill: "#D0B970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.7136H9.52051V19.7763H13.4511V19.7136Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.7763H9.52051V19.8389H13.4511V19.7763Z",
    fill: "#D0B96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.839H9.52051V19.9016H13.4511V19.839Z",
    fill: "#D0B86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.9023H9.52051V19.9649H13.4511V19.9023Z",
    fill: "#D0B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 19.965H9.52051V20.0276H13.4511V19.965Z",
    fill: "#CFB86C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.0276H9.52051V20.0903H13.4511V20.0276Z",
    fill: "#CFB86B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.0903H9.52051V20.1529H13.4511V20.0903Z",
    fill: "#CFB76B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.1536H9.52051V20.2162H13.4511V20.1536Z",
    fill: "#CFB76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.2163H9.52051V20.2789H13.4511V20.2163Z",
    fill: "#CFB769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.2789H9.52051V20.3416H13.4511V20.2789Z",
    fill: "#CEB668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.3416H9.52051V20.4042H13.4511V20.3416Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.4049H9.52051V20.4676H13.4511V20.4049Z",
    fill: "#CEB667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.4676H9.52051V20.5302H13.4511V20.4676Z",
    fill: "#CEB666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.5302H9.52051V20.5929H13.4511V20.5302Z",
    fill: "#CEB565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.5936H9.52051V20.6562H13.4511V20.5936Z",
    fill: "#CEB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.6562H9.52051V20.7189H13.4511V20.6562Z",
    fill: "#CDB564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.7189H9.52051V20.7815H13.4511V20.7189Z",
    fill: "#CDB563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.7815H9.52051V20.8442H13.4511V20.7815Z",
    fill: "#CDB562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.8449H9.52051V20.9075H13.4511V20.8449Z",
    fill: "#CDB462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.9075H9.52051V20.9702H13.4511V20.9075Z",
    fill: "#CDB461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 20.9702H9.52051V21.0328H13.4511V20.9702Z",
    fill: "#CDB460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.0328H9.52051V21.0955H13.4511V21.0328Z",
    fill: "#CDB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.0962H9.52051V21.1588H13.4511V21.0962Z",
    fill: "#CCB45F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.1588H9.52051V21.2215H13.4511V21.1588Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.2215H9.52051V21.2841H13.4511V21.2215Z",
    fill: "#CCB35E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.2848H9.52051V21.3475H13.4511V21.2848Z",
    fill: "#CCB35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.3475H9.52051V21.4101H13.4511V21.3475Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.4101H9.52051V21.4728H13.4511V21.4101Z",
    fill: "#CCB35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.4728H9.52051V21.5354H13.4511V21.4728Z",
    fill: "#CCB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.5361H9.52051V21.5988H13.4511V21.5361Z",
    fill: "#CBB25B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.5988H9.52051V21.6614H13.4511V21.5988Z",
    fill: "#CBB25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.6614H9.52051V21.7241H13.4511V21.6614Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.7241H9.52051V21.7868H13.4511V21.7241Z",
    fill: "#CBB259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.7874H9.52051V21.8501H13.4511V21.7874Z",
    fill: "#CBB258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.8501H9.52051V21.9128H13.4511V21.8501Z",
    fill: "#CBB158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.9128H9.52051V21.9754H13.4511V21.9128Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 21.9754H9.52051V22.0381H13.4511V21.9754Z",
    fill: "#CBB157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.0388H9.52051V22.1014H13.4511V22.0388Z",
    fill: "#CBB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.1014H9.52051V22.164H13.4511V22.1014Z",
    fill: "#CAB156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.1641H9.52051V22.2267H13.4511V22.1641Z",
    fill: "#CAB155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.2274H9.52051V22.2901H13.4511V22.2274Z",
    fill: "#CAB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.2901H9.52051V22.3527H13.4511V22.2901Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.3527H9.52051V22.4154H13.4511V22.3527Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.4154H9.52051V22.478H13.4511V22.4154Z",
    fill: "#CAB054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.4787H9.52051V22.5414H13.4511V22.4787Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.5414H9.52051V22.604H13.4511V22.5414Z",
    fill: "#CAB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.604H9.52051V22.6667H13.4511V22.604Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.6667H9.52051V22.7293H13.4511V22.6667Z",
    fill: "#CAB052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.73H9.52051V22.7927H13.4511V22.73Z",
    fill: "#CAAF52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.7927H9.52051V22.8553H13.4511V22.7927Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.8553H9.52051V22.918H13.4511V22.8553Z",
    fill: "#C9AF51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.9187H9.52051V22.9813H13.4511V22.9187Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 22.9813H9.52051V23.044H13.4511V22.9813Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.044H9.52051V23.1066H13.4511V23.044Z",
    fill: "#C9AF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.1066H9.52051V23.1693H13.4511V23.1066Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.17H9.52051V23.2326H13.4511V23.17Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.2326H9.52051V23.2953H13.4511V23.2326Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.2953H9.52051V23.3579H13.4511V23.2953Z",
    fill: "#C9AF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.3579H9.52051V23.4206H13.4511V23.3579Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.4213H9.52051V23.4839H13.4511V23.4213Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.4839H9.52051V23.5466H13.4511V23.4839Z",
    fill: "#C9AE4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.5466H9.52051V23.6093H13.4511V23.5466Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.6099H9.52051V23.6726H13.4511V23.6099Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.6726H9.52051V23.7352H13.4511V23.6726Z",
    fill: "#C9AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.7352H9.52051V23.7979H13.4511V23.7352Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.7979H9.52051V23.8606H13.4511V23.7979Z",
    fill: "#C8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.8612H9.52051V23.9239H13.4511V23.8612Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.9239H9.52051V23.9865H13.4511V23.9239Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 23.9865H9.52051V24.0492H13.4511V23.9865Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.0492H9.52051V24.1119H13.4511V24.0492Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.1125H9.52051V24.1752H13.4511V24.1125Z",
    fill: "#C8AE4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.1752H9.52051V24.2379H13.4511V24.1752Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.2379H9.52051V24.3005H13.4511V24.2379Z",
    fill: "#C8AE4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.3012H9.52051V24.3638H13.4511V24.3012Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.3639H9.52051V24.4265H13.4511V24.3639Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.4265H9.52051V24.4892H13.4511V24.4265Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.4892H9.52051V24.5518H13.4511V24.4892Z",
    fill: "#C8AD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.5525H9.52051V24.6152H13.4511V24.5525Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.6152H9.52051V24.6778H13.4511V24.6152Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.6778H9.52051V24.7405H13.4511V24.6778Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.7405H9.52051V24.8031H13.4511V24.7405Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.8038H9.52051V24.8665H13.4511V24.8038Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.8665H9.52051V24.9291H13.4511V24.8665Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.9291H9.52051V24.9918H13.4511V24.9291Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 24.9925H9.52051V25.0551H13.4511V24.9925Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.0551H9.52051V25.1178H13.4511V25.0551Z",
    fill: "#C8AD4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.1178H9.52051V25.1804H13.4511V25.1178Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.1804H9.52051V25.2431H13.4511V25.1804Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.2438H9.52051V25.3064H13.4511V25.2438Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.3064H9.52051V25.3691H13.4511V25.3064Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.3691H9.52051V25.4317H13.4511V25.3691Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.4317H9.52051V25.4944H13.4511V25.4317Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.4951H9.52051V25.5577H13.4511V25.4951Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.5577H9.52051V25.6204H13.4511V25.5577Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.6204H9.52051V25.683H13.4511V25.6204Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.6837H9.52051V25.7464H13.4511V25.6837Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.7464H9.52051V25.809H13.4511V25.7464Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.809H9.52051V25.8717H13.4511V25.809Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.8717H9.52051V25.9344H13.4511V25.8717Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.935H9.52051V25.9977H13.4511V25.935Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 25.9977H9.52051V26.0604H13.4511V25.9977Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 26.0603H9.52051V26.123H13.4511V26.0603Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 26.123H9.52051V26.1857H13.4511V26.123Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 26.1864H9.52051V26.249H13.4511V26.1864Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 26.249H9.52051V26.3117H13.4511V26.249Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 26.3116H9.52051V26.3743H13.4511V26.3116Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 26.375H9.52051V26.4377H13.4511V26.375Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 26.4377H9.52051V26.5003H13.4511V26.4377Z",
    fill: "#C8AD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4511 26.5003H9.52051V26.563H13.4511V26.5003Z",
    fill: "#C8AD49"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9541 23.0701L50.4408 21.717H46.0683L45.555 23.1002C45.3543 23.6398 45.1835 24.004 45.0417 24.1928C44.8999 24.3817 44.6671 24.4761 44.3452 24.4761C44.071 24.4761 43.8288 24.3755 43.6187 24.1742C43.4087 23.9729 43.3031 23.7456 43.3031 23.4904C43.3031 23.343 43.3279 23.1915 43.3766 23.0338C43.4252 22.8771 43.5059 22.6582 43.6187 22.3791L46.3695 15.376C46.4481 15.1747 46.5423 14.934 46.652 14.6518C46.7617 14.3695 46.8797 14.136 47.0039 13.9493C47.1281 13.7625 47.2926 13.612 47.4955 13.4969C47.6983 13.3817 47.9487 13.3236 48.2478 13.3236C48.5469 13.3236 48.8046 13.3817 49.0074 13.4969C49.2103 13.612 49.3738 13.7604 49.499 13.942C49.6242 14.1236 49.7288 14.3187 49.8147 14.5272C49.9006 14.7358 50.0092 15.0139 50.1406 15.3625L52.9504 22.3209C53.1708 22.8501 53.2805 23.2351 53.2805 23.4758C53.2805 23.7166 53.177 23.9552 52.969 24.1638C52.761 24.3724 52.5106 24.4761 52.2166 24.4761C52.0459 24.4761 51.8989 24.445 51.7768 24.3838C51.6547 24.3225 51.5522 24.2395 51.4684 24.1337C51.3856 24.0279 51.2956 23.866 51.2004 23.6481C51.1052 23.4302 51.0234 23.2372 50.9551 23.0712L50.9541 23.0701ZM46.6406 20.0765H49.854L48.2323 15.6261L46.6406 20.0765Z",
    fill: "#100F0F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6071 14.6476V22.4963H63.023C63.3749 22.4963 63.645 22.5824 63.8333 22.7536C64.0217 22.9248 64.1158 23.1407 64.1158 23.4011C64.1158 23.6616 64.0227 23.8805 63.8375 24.0445C63.6512 24.2084 63.38 24.2914 63.023 24.2914H57.7626C57.2886 24.2914 56.9471 24.1856 56.7391 23.9749C56.5311 23.7643 56.4276 23.4229 56.4276 22.9529V14.6486C56.4276 14.2076 56.527 13.8766 56.7246 13.6556C56.9223 13.4346 57.1831 13.3246 57.506 13.3246C57.8289 13.3246 58.099 13.4336 58.3018 13.6525C58.5046 13.8704 58.6061 14.2035 58.6061 14.6497L58.6071 14.6476Z",
    fill: "#100F0F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0665 19.6791H69.3038V23.1438C69.3038 23.6003 69.2034 23.9355 69.0027 24.1513C68.8019 24.3672 68.5401 24.4751 68.2182 24.4751C67.8705 24.4751 67.6025 24.362 67.411 24.1368C67.2206 23.9116 67.1254 23.5806 67.1254 23.1438V14.8468C67.1254 14.3757 67.2309 14.0354 67.441 13.8248C67.6511 13.6141 67.9916 13.5083 68.4604 13.5083H72.0039C72.4923 13.5083 72.9115 13.529 73.2582 13.5705C73.6059 13.612 73.9184 13.6971 74.1968 13.8248C74.5342 13.9669 74.8322 14.1703 75.092 14.4349C75.3507 14.6995 75.5484 15.0077 75.6829 15.3584C75.8174 15.7091 75.8847 16.0806 75.8847 16.4728C75.8847 17.277 75.6581 17.9193 75.2058 18.3997C74.7536 18.8801 74.0674 19.2215 73.1485 19.4218C73.5345 19.6283 73.9039 19.9323 74.2558 20.3339C74.6077 20.7365 74.9223 21.164 75.1986 21.6174C75.4749 22.0709 75.6902 22.4807 75.8444 22.846C75.9986 23.2112 76.0751 23.4623 76.0751 23.6003C76.0751 23.7384 76.0296 23.8836 75.9396 24.0227C75.8485 24.1627 75.7253 24.2727 75.5691 24.3537C75.4128 24.4346 75.2317 24.4751 75.0258 24.4751C74.7815 24.4751 74.5756 24.417 74.409 24.3018C74.2423 24.1866 74.0995 24.0403 73.9795 23.8639C73.8594 23.6875 73.6969 23.4271 73.492 23.0846L72.6186 21.6278C72.306 21.0934 72.0256 20.6867 71.7783 20.4065C71.5309 20.1274 71.2805 19.9354 71.0259 19.8327C70.7713 19.73 70.4515 19.6781 70.0645 19.6781L70.0665 19.6791ZM71.3136 15.1477H69.3038V18.1123H71.2556C71.7793 18.1123 72.2191 18.0666 72.5762 17.9763C72.9332 17.8861 73.2054 17.7315 73.3937 17.5125C73.5821 17.2946 73.6762 16.9937 73.6762 16.6118C73.6762 16.313 73.6007 16.0494 73.4486 15.8212C73.2964 15.5929 73.0864 15.4227 72.8173 15.3096C72.5627 15.2017 72.0618 15.1477 71.3136 15.1477Z",
    fill: "#100F0F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6258 23.1438V14.6476C79.6258 14.2066 79.7262 13.8756 79.927 13.6546C80.1277 13.4336 80.3864 13.3236 80.7042 13.3236C81.0219 13.3236 81.2972 13.4325 81.5 13.6515C81.7028 13.8694 81.8043 14.2025 81.8043 14.6486V23.1448C81.8043 23.591 81.7028 23.9251 81.5 24.1451C81.2972 24.3661 81.0312 24.4761 80.7042 24.4761C80.3771 24.4761 80.1329 24.3641 79.9301 24.141C79.7272 23.9179 79.6258 23.5848 79.6258 23.1438Z",
    fill: "#100F0F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.232 23.1438V19.7237L85.6054 15.6417C85.3757 15.2743 85.2132 14.9869 85.118 14.7815C85.0228 14.576 84.9752 14.3965 84.9752 14.245C84.9752 13.9949 85.0714 13.7791 85.2649 13.5975C85.4585 13.4159 85.6965 13.3257 85.98 13.3257C86.2781 13.3257 86.5047 13.4107 86.6589 13.5799C86.8131 13.749 87.0439 14.0862 87.3523 14.5916L89.3621 17.8643L91.3946 14.5916C91.5167 14.3903 91.6192 14.2211 91.703 14.0842C91.7858 13.9472 91.8779 13.8185 91.9783 13.6982C92.0787 13.5778 92.1894 13.4865 92.3126 13.4222C92.4347 13.3589 92.5837 13.3267 92.7596 13.3267C93.0339 13.3267 93.2626 13.4159 93.4458 13.5954C93.6289 13.775 93.7211 13.9814 93.7211 14.217C93.7211 14.4079 93.6745 14.5999 93.5813 14.7908C93.4882 14.9817 93.3299 15.2463 93.1043 15.5856L90.4115 19.7268V23.1469C90.4115 23.5931 90.309 23.9272 90.1031 24.1472C89.8971 24.3682 89.6363 24.4782 89.3186 24.4782C89.0009 24.4782 88.7339 24.3692 88.5331 24.1503C88.3324 23.9324 88.232 23.5972 88.232 23.1459V23.1438Z",
    fill: "#100F0F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.752 23.0701L102.238 21.717H97.8658L97.3525 23.1002C97.1517 23.6398 96.9809 24.004 96.8392 24.1928C96.6974 24.3817 96.4645 24.4761 96.1427 24.4761C95.8684 24.4761 95.6263 24.3755 95.4162 24.1742C95.2061 23.9729 95.1005 23.7456 95.1005 23.4904C95.1005 23.343 95.1254 23.1915 95.174 23.0338C95.2227 22.8771 95.3034 22.6582 95.4162 22.3791L98.1669 15.376C98.2456 15.1747 98.3398 14.934 98.4495 14.6518C98.5592 14.3695 98.6771 14.136 98.8013 13.9493C98.9255 13.7625 99.09 13.612 99.2929 13.4969C99.4957 13.3817 99.7462 13.3236 100.045 13.3236C100.344 13.3236 100.602 13.3817 100.805 13.4969C101.008 13.612 101.171 13.7604 101.296 13.942C101.422 14.1236 101.526 14.3187 101.612 14.5272C101.698 14.7358 101.807 15.0139 101.938 15.3625L104.748 22.3209C104.968 22.8501 105.078 23.2351 105.078 23.4758C105.078 23.7166 104.974 23.9552 104.766 24.1638C104.558 24.3724 104.308 24.4761 104.014 24.4761C103.843 24.4761 103.696 24.445 103.574 24.3838C103.452 24.3225 103.35 24.2395 103.266 24.1337C103.183 24.0279 103.093 23.866 102.998 23.6481C102.903 23.4302 102.821 23.2372 102.753 23.0712L102.752 23.0701ZM98.4381 20.0765H101.651L100.03 15.6261L98.4381 20.0765Z",
    fill: "#100F0F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.619 13.5072H112.458C113.197 13.5072 113.83 13.5757 114.358 13.7137C114.886 13.8517 115.366 14.108 115.795 14.4857C116.915 15.4466 117.475 16.9086 117.475 18.8698C117.475 19.5173 117.419 20.1077 117.306 20.6421C117.194 21.1764 117.021 21.6579 116.786 22.0875C116.551 22.5171 116.251 22.9 115.883 23.2382C115.595 23.4987 115.279 23.7062 114.937 23.8639C114.595 24.0206 114.226 24.1316 113.833 24.1949C113.44 24.2593 112.996 24.2904 112.501 24.2904H109.663C109.266 24.2904 108.968 24.2302 108.767 24.1098C108.567 23.9895 108.436 23.8203 108.375 23.6024C108.314 23.3845 108.283 23.1013 108.283 22.7526V14.8448C108.283 14.3737 108.389 14.0333 108.599 13.8227C108.809 13.612 109.149 13.5062 109.618 13.5062L109.619 13.5072ZM110.463 15.236V22.5544H112.113C112.475 22.5544 112.759 22.5451 112.964 22.5254C113.169 22.5057 113.382 22.4569 113.602 22.378C113.823 22.2992 114.013 22.1892 114.175 22.047C114.903 21.4296 115.268 20.365 115.268 18.8542C115.268 17.7906 115.107 16.9937 114.787 16.4635C114.467 15.9343 114.072 15.5971 113.602 15.4518C113.133 15.3076 112.565 15.2349 111.9 15.2349H110.463V15.236Z",
    fill: "#100F0F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.292 23.0701L126.779 21.717H122.406L121.893 23.1002C121.692 23.6398 121.522 24.004 121.38 24.1928C121.238 24.3817 121.005 24.4761 120.683 24.4761C120.409 24.4761 120.167 24.3755 119.957 24.1742C119.747 23.9729 119.641 23.7456 119.641 23.4904C119.641 23.343 119.666 23.1915 119.715 23.0338C119.763 22.8771 119.844 22.6582 119.957 22.3791L122.708 15.376C122.786 15.1747 122.88 14.934 122.99 14.6518C123.1 14.3695 123.218 14.136 123.342 13.9493C123.466 13.7625 123.631 13.612 123.833 13.4969C124.036 13.3817 124.287 13.3236 124.586 13.3236C124.885 13.3236 125.143 13.3817 125.345 13.4969C125.548 13.612 125.712 13.7604 125.837 13.942C125.962 14.1236 126.067 14.3187 126.153 14.5272C126.239 14.7358 126.347 15.0139 126.479 15.3625L129.288 22.3209C129.509 22.8501 129.619 23.2351 129.619 23.4758C129.619 23.7166 129.515 23.9552 129.307 24.1638C129.099 24.3724 128.849 24.4761 128.555 24.4761C128.384 24.4761 128.237 24.445 128.115 24.3838C127.993 24.3225 127.89 24.2395 127.806 24.1337C127.724 24.0279 127.634 23.866 127.538 23.6481C127.443 23.4302 127.361 23.2372 127.293 23.0712L127.292 23.0701ZM122.979 20.0765H126.192L124.57 15.6261L122.979 20.0765Z",
    fill: "#100F0F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c52ae618a52ab39bfdf82b7c77281597.svg";
export { ForwardRef as ReactComponent };